import type { TranslationKeys } from './es';

const en: TranslationKeys = {
  nav: { services: 'Services', about: 'About Us', blog: 'Blog', zones: 'Zones', contact: 'Contact', login: 'Sign In', clientArea: 'Client Area', language: 'Language', home: 'Home', access: 'Access', search: 'Search Punto Hispano', searchPlaceholder: 'What are you looking for? E.g.: insurance, housing...', noResults: 'No results found for', tryOther: 'Try other terms', popularSearches: 'Popular searches:', quickAccess: 'Quick access:', freeConsultation: 'Free Consultation', allZones: 'All Zones', digitalBusiness: 'Digital Business', aboutUs: 'About Us', closeMenu: 'Close menu', openMenu: 'Open menu' },
  hero: { title: 'Your Administration Partner in Switzerland', subtitle: 'Administration, legal advice, insurance, languages and digital solutions for expats in Switzerland.', cta: 'Free Consultation', ctaSecondary: 'View Services', trustBadge: '+2,500 families trust us', experience: '+12 years of experience', act: 'ACT I', actSubtitle: 'WHO WE ARE', titleLine1: 'ADMINISTRATION &', titleLine2: 'CONSULTING', titleLine3: 'IN SWITZERLAND', cinematicSubtitle: 'Your bridge to success in Switzerland. Over 12 years helping English speakers.', discoverServices: 'Discover Services', scheduleConsultation: 'Schedule Consultation' },
  services: { title: 'Our Services', subtitle: 'Everything for a worry-free life in Switzerland', gestoria: { name: 'Administration & Management', description: 'Complete management: RAV, taxes, permits, CV, translations.', cta: 'View Services' }, legal: { name: 'Legal Advice', description: 'Immigration, labor, family, commercial law.', cta: 'Legal Advice' }, seguros: { name: 'Insurance & Pension', description: 'Health, life, home, vehicle insurance.', cta: 'Free Quote' }, idiomas: { name: 'Language Courses', description: 'German and English. Levels A1-C1.', cta: 'View Courses' }, digital: { name: 'Digital Solutions', description: 'Web design, CRM, AI automation.', cta: 'View Portfolio' }, relocation: { name: 'Relocation Pack', description: 'Everything for your move to Switzerland.', cta: 'Full Package' }, vehiculos: { name: 'Vehicle Rental', description: 'Car and van rental.', cta: 'View Vehicles' }, viviendas: { name: 'Housing Rental', description: 'Apartments and rooms.', cta: 'View Housing' }, resultsTitle: 'RESULTS THAT', resultsTitleAccent: 'TRANSFORM', resultsSubtitle: 'Each service solves a real problem.', viewAll: 'View all services', explore: 'Explore', gestoriaShort: 'Administration', gestoriaDesc: 'Taxes, permits and procedures resolved stress-free.', gestoriaTags: 'Taxes • Permits • RAV', legalShort: 'Legal Advice', legalDesc: 'Protect your rights.', legalTags: 'Contracts • Inheritance • Visas', idiomasShort: 'Languages', idiomasDesc: 'Break the language barrier.', idiomasTags: 'German • English • Certificates', segurosShort: 'Insurance', segurosDesc: 'Save up to 35% on premiums.', segurosTags: 'Health • 3rd Pillar • Life', vehiculosShort: 'Car Rental', vehiculosDesc: 'Move freely from day one.', vehiculosTags: 'Sedans • Vans • SUV', viviendasShort: 'Housing Rental', viviendasDesc: 'Find your home without competing.', viviendasTags: 'Rooms • Apartments • Shared', digitalShort: 'Digital Solutions', digitalDesc: 'Multiply sales with professional website, CRM and AI.', digitalTags: 'Web • CRM • AI', relocationShort: 'Relocation Pack', relocationDesc: 'Arrive in Switzerland worry-free.', relocationTags: 'All-inclusive', badgeBestSeller: 'Best Seller', badgeNew: 'New', badgeSave: 'Save 25%', act: 'ACT II', actSubtitle: 'SERVICES' },
  process: { act: 'ACT III', actSubtitle: 'PROCESS', title: 'FROM YOUR PROBLEM TO', titleAccent: 'YOUR SOLUTION', subtitle: 'No fine print, no complications. That simple.', step1Title: 'We Listen', step1Desc: 'Tell us what keeps you up at night.', step1Duration: 'Free', step2Title: 'No-Surprise Plan', step2Desc: 'You\'ll know exactly what we do and how much it costs.', step2Duration: '24-48h', step3Title: 'We Execute', step3Desc: 'You go on with your life. We resolve for you.', step3Duration: 'Variable', step4Title: 'Problem Solved', step4Desc: 'We stay with you until everything is 100% sorted.', step4Duration: 'Ongoing' },
  about: { title: 'About Us', subtitle: 'Meet the team behind Punto Hispano', mission: 'Our mission is to make life in Switzerland easier.', heroTitle: 'Who are we?', heroSubtitle: 'We\'re the bridge between your language and Swiss bureaucracy. Since 2013.', stats: { families: 'Families', procedures: 'Procedures', companies: 'Companies', years: 'Years' }, timeline: { t2013: { title: 'The First Step', desc: 'Santiago arrives in Switzerland.' }, t2019: { title: 'Growth Without Borders', desc: 'Hundreds of clients.' }, t2023: { title: 'Our Home in Zurich', desc: 'Office in Opfikon.' }, t2025: { title: 'Over 2,500 Families', desc: 'Multidisciplinary team.' } }, valuesTitle: 'Our Values', values: { transparency: { title: 'Total Transparency', desc: 'No fine print.' }, empathy: { title: 'Real Empathy', desc: 'We\'ve been in your shoes.' }, results: { title: 'Results, Not Words', desc: 'Problems solved, not promises.' } } },
  contact: { title: 'Contact', subtitle: 'Have questions? We\'re here to help', name: 'Name', email: 'Email', phone: 'Phone', message: 'Message', send: 'Send Message', whatsapp: 'Message us on WhatsApp', schedule: 'Schedule Consultation', address: 'Thurgauerstrasse 117, 1st Floor, Office 181, 8152 Opfikon, Zurich', heroTitle: 'How can we help you?', heroSubtitle: 'We\'re just a message away. First consultation free.', officeTitle: 'Our Office', hours: 'Hours: Mon-Fri 09:00-18:00', responseTime: 'We respond within 2 hours', freeConsultation: 'First consultation 100% free' },
  zones: { title: 'Service Zones', subtitle: 'From Zurich, for the whole world', description: 'Administration, legal advice, insurance and more.', headquarters: 'Headquarters', cities: 'cities', countriesTitle: 'Countries with Greatest Presence', notFound: 'Can\'t find your zone?', notFoundDesc: 'We can help you online.', servicesIn: 'Services in', heroTitle: 'Wherever You Are, We Help', heroSubtitle: 'Professional services from Zurich for all of Europe.', europeTitle: 'Europe', allCountries: 'View all countries', remoteServices: '100% online services available' },
  blog: { title: 'Blog', subtitle: 'Tips, guides and news', readMore: 'Read more', readTime: 'min read', categories: 'Categories', search: 'Search articles...' },
  footer: { description: 'Your administration partner in Switzerland', rights: 'All rights reserved', privacy: 'Privacy Policy', cookies: 'Cookie Policy', legal: 'Legal Notice', gdpr: 'GDPR', brandDesc: 'Your integral partner in Switzerland.', newsletter: 'Newsletter', newsletterDesc: 'Get news, tips and exclusive offers', subscribe: 'Subscribe', emailPlaceholder: 'name@example.com', followUs: 'Follow us on', servicesTitle: 'Services', gestoriaTitle: 'Administration', lifestyleTitle: 'Lifestyle', zonesTitle: 'Zones', companyTitle: 'Company', legalTitle: 'Legal', zonesLink: 'Service Zones', madeWith: 'Built with ❤️ by', desempleo: 'Unemployment (RAV)', administracion: 'Administration', cvDoc: 'CV & Documents', acompanamientos: 'Accompaniments', traducciones: 'Translations', paquetes: 'Special Packages' },
  common: { learnMore: 'Learn More', viewAll: 'View All', back: 'Back', next: 'Next', previous: 'Previous', close: 'Close', loading: 'Loading...', error: 'An error occurred', retry: 'Retry', search: 'Search', noResults: 'No results', freeConsultation: 'Free Consultation', whatsapp: 'WhatsApp', schedule: 'Book Appointment', callUs: 'Call Us', from: 'From', our: 'Our', all: 'All' },
  audience: { trustLine: 'Over 12 years helping English speakers in Switzerland', empathy: 'Sound familiar?', empathyItems: ['You don\'t understand official letters', 'You feel lost with Swiss bureaucracy', 'You need help with taxes', 'You\'re looking for someone who speaks your language'], processTitle: 'That Easy', processSteps: [{ title: 'Tell us your case', description: 'Via WhatsApp or appointment' }, { title: 'We advise you', description: 'Analysis and options' }, { title: 'We solve it', description: 'Professional management for you' }] },
  navStructure: { traditional: 'Traditional', lifestyle: 'Lifestyle', digital: 'Digital', europe: 'Europe', america: 'America', other: 'Other', viewAllZones: 'View all zones', desempleo: 'Unemployment & RAV', administracion: 'Administration', cvDoc: 'CV & Documents', traducciones: 'Translations', paquetes: 'Special Packages', extranjeria: 'Immigration & Permits', laboral: 'Labor Law', familia: 'Family Law', mercantil: 'Commercial Law', inmobiliario: 'Real Estate & Tax', aleman: 'German', ingles: 'English', seguroSalud: 'Health Insurance', vidaPension: 'Life & Pension', hogarVehiculos: 'Home & Vehicle', siniestros: 'Claims', comparador: 'Comparator', packBasico: 'Basic Pack', packCompleto: 'Full Pack', paraEmpresas: 'For Companies', packRetorno: 'Return Pack', formacionIdiomas: 'Language Courses', segurosYPensiones: 'Insurance & Pension', alquilerVehiculos: 'Vehicle Rental', alquilerViviendas: 'Housing Rental', solucionesDigitales: 'Digital Solutions' },
  testimonials: { act: 'ACT IV', actSubtitle: 'TESTIMONIALS', title: 'THEY ALREADY LIVE', titleAccent: 'WORRY-FREE', subtitle: 'Real stories from people like you', reviews: 'reviews', viewReal: 'View real reviews on Google Maps', disclaimer: 'The reviews shown below are representative of our clients\' experience. To see our authentic and verified reviews, visit our Google Maps profile.' },
  faq: { act: 'ACT V', actSubtitle: 'FAQ', title: 'FREQUENTLY ASKED', titleAccent: 'QUESTIONS', subtitle: 'Everything you need to know.', ctaText: 'Have another question?', ctaLink: 'Contact us directly', showMore: 'Show more questions', showLess: 'Show less' },
  cta: { act: 'ACT VI', actSubtitle: 'CONTACT', urgencyBadge: 'Limited spots — Only 5 free consultations this week', title: 'DON\'T WAIT UNTIL', titleAccent: 'IT\'S TOO LATE', subtitle: 'Every day without resolving is unnecessary stress. Take the first step — it\'s free.', step1Label: 'Select service', step2Label: 'Details', step3Label: 'Confirmation', stepTitle: 'Which service interests you?', continueBtn: 'Continue to step 2', trustResponse: 'We respond within 24h', trustFamilies: '+2500 families already solved it', trustLanguage: '100% in your language', serviceOther: 'Other / Not sure' },
  trust: { headline: '+2,500 people freed themselves from Swiss bureaucracy', verifiedLabel: 'Verified companies:', dataProtected: '100% Data Protected', dataProtectedSub: 'Your information is sacred', registered: 'Registered company in Switzerland', registeredSub: 'Verifiable on Moneyhouse', realOffice: 'Real office in Zurich', realOfficeSub: 'Not a mailbox', experience: '12+ years, 2500+ families', experienceSub: 'Proven results' },
  homeFaq: { questions: [{ question: 'I just arrived in Switzerland and don\'t know where to start. Can you help?', answer: 'Absolutely. We know how overwhelming it is to arrive in a new country with a different language, laws and bureaucracy. Our Relocation Pack covers everything: permits, insurance, bank, housing and more. A personal coordinator guides you step by step.' }, { question: 'How much does the first consultation cost? Is there any commitment?', answer: 'The first consultation is 100% free and no commitment. In 15 minutes we listen to your case, understand what you need, and explain how we can help. If you decide not to continue, no problem. Zero pressure.' }, { question: 'I\'m paying too much in taxes. Can you optimize my tax return?', answer: 'That\'s what we do best. In 12+ years we\'ve recovered thousands of francs for our clients with deductions they didn\'t know about. We prepare your complete return, legally optimize your tax burden and represent you before the authorities if needed.' }, { question: 'I have a legal problem and don\'t understand Swiss law. What do I do?', answer: 'You\'re not alone. Our legal advisors speak your language and know Swiss law in detail. Employment contracts, family reunification, inheritance, permits — we protect and defend your rights so you can sleep peacefully.' }, { question: 'I need to learn German but conventional courses don\'t work for me.', answer: 'Because they\'re not designed for Spanish speakers. Our methodology starts from the specific difficulties of Spanish to German. Courses from A1 to C1, in-person in Zurich or online. Certified teachers who understand how you learn.' }, { question: 'How do I know if I\'m overpaying for my health insurance?', answer: 'You probably are — 70% of our clients save an average of 35% after our free comparison. We analyze your premiums, deductibles and coverage, and manage the complete switch without you having to do anything.' }, { question: 'Do you only serve in Zurich or also remotely?', answer: 'Our office is in Opfikon (Zurich), but we serve clients from all over Switzerland and abroad. 80% of our services are 100% online. No matter where you are — distance is no excuse for leaving problems unresolved.' }, { question: 'Why should I trust Punto Hispano and not another provider?', answer: 'Because we are a registered company, verifiable on Moneyhouse (Gestoría GmbH, Immobilien GmbH, Holding GmbH). Over 2,500 families have chosen us. 4.9 stars on Google. And most importantly: we speak your language and understand your reality because we\'ve lived it.' }], additionalQuestions: [{ question: 'Where are you exactly? Can I come to the office?', answer: 'Yes, we\'re at Thurgauerstrasse 117, 8152 Opfikon, Zurich (1st Floor, Office 181). Monday to Friday 9:00-18:00, Saturdays by appointment. Come meet us — we\'re real people, not an online form.' }, { question: 'I want to secure my retirement. What options do I have with the 3rd Pillar?', answer: 'The 3rd Pillar is the best tool to secure your future AND save on taxes today. We compare all market options (3a and 3b), optimize your tax strategy and manage transfers. Every year you wait, you lose money.' }, { question: 'My business needs a digital presence. Can you help?', answer: 'We design websites that sell, not just exist. Custom CRM, AI automation, digital marketing and SEO. Our clients double their online acquisition in the first 3 months.' }, { question: 'I need a car but don\'t want complications with long contracts.', answer: 'Flexible rental: from days to months. City cars, SUVs and vans. Comprehensive insurance included, service in Spanish and 24/7 assistance. Move freely without ties.' }, { question: 'Finding an apartment in Switzerland is impossible. Can you really help me?', answer: 'We know how frustrating it is. We have access to an exclusive network of landlords, manage viewings, negotiate conditions and accompany you to signing. You don\'t compete alone — you compete with advantage.' }, { question: 'What exactly does the Relocation Pack include?', answer: 'EVERYTHING: housing search, bank account opening, municipal registration, mandatory insurance, Swiss-market adapted CV, German courses, school guidance for your children and a personal coordinator. Save 25% vs. hiring each service separately.' }, { question: 'How do I pay? Do you accept installments?', answer: 'Transfer, card, TWINT or PayPal. And yes, we offer installments for larger services. We don\'t want money to be an obstacle to solving your problems.' }, { question: 'I don\'t have a residence permit yet. Can you still help me?', answer: 'Yes. We help regularize immigration situations and advise on the best routes to obtain your permit. The sooner you act, the more options you have. Don\'t wait until it becomes a bigger problem.' }] },
  seo: { homeTitle: 'Punto Hispano | Administration Services in Switzerland', homeDescription: 'Best administration and consulting in Zurich. Taxes, legal, insurance, German courses, relocation and digital solutions.' },
  servicesIndex: { heroTitle: 'All Our Services', heroSubtitle: 'Your complete solution in Switzerland.', heroCta: 'Free Consultation via WhatsApp', categories: { gestoria: { title: 'Administration & Management', description: 'Taxes, RAV, permits — we handle everything.', cta: 'Stop worrying', features: ['Error-free tax returns', 'Permits up to date', 'No stress', 'Real tax savings'] }, legal: { title: 'Legal Advice', description: 'A contract you don\'t understand can cost thousands.', cta: 'Protect my rights', features: ['Reviewed contracts', 'Permits resolved', 'Family reunification', 'Legal peace of mind'] }, idiomas: { title: 'Language Courses', description: 'No language, no job. Our courses make you speak.', cta: 'Start speaking', features: ['Native teachers', 'Levels A1-C1', 'Small groups', 'Official certificates'] }, seguros: { title: 'Insurance & Pension', description: 'Every year you lose hundreds by not comparing.', cta: 'Compare and save', features: ['Save up to 35%', 'Personal advisor', 'All providers', 'No commitment'] }, digital: { title: 'Digital Solutions', description: 'Your competition already has a website and CRM. And you?', cta: 'See what we can do', features: ['Professional website', 'Custom CRM', 'AI & automation', 'Digital marketing'] }, vehiculos: { title: 'Vehicle Rental', description: 'Move freely. Cars, vans and SUVs.', cta: 'View vehicles', features: ['No excessive deposit', 'Insurance included', 'Flexible pickup', 'Competitive prices'] }, viviendas: { title: 'Housing Rental', description: 'Find your home without competing with 200 candidates.', cta: 'Search housing', features: ['Verified', 'No hidden fees', 'Short & long term', 'Central locations'] }, relocation: { title: 'Relocation Pack', description: 'Arrive in Switzerland with everything sorted.', cta: 'Arrive stress-free', features: ['All-inclusive', 'Personal advisor', 'Before arrival', 'Result guarantee'] } } },
  aboutPage: { seoTitle: 'About Punto Hispano — Administration Services in Switzerland', seoDesc: 'Meet Punto Hispano: 12+ years helping people in Switzerland.', heroSub: 'About Punto Hispano — Administration Services in Switzerland', heroTitle1: 'The Trusted Administration', heroTitle2: 'for ', heroTitle3: 'Spanish Speakers', heroTitle4: 'in Switzerland', heroDesc: 'We arrived in Switzerland just like you. We know what it feels like not to understand a tax letter or sign a contract blindly. That\'s why we created Punto Hispano.', knowServices: 'Discover Our Services →', talkToUs: 'Talk to Us', originTitle: 'We Didn\'t Create a Company. We Solved a Problem We Lived Firsthand.', originP1: 'In 2013, Santiago Castillo faced the same thing you did: a new country, a language he didn\'t master. He looked for help in Spanish and couldn\'t find it. So he created it.', originP2: 'Today, Punto Hispano is where 2,500+ families have found someone who speaks their language and fights for their rights.', originP3: 'We are not a company that sells services. We are people who solved the same problem you have now.', originBadge: '🇨🇭 From Zurich, for the entire community in Switzerland', timelineTitle: '12 Years Growing With You', founderTag: 'Founder', founderName: 'Santiago Castillo', founderQuote: '"I arrived in Switzerland with a suitcase and zero contacts. Nobody explained taxes, insurance, or permits. Help in Spanish didn\'t exist. So I created it."', founderDesc: 'Today, over 12 years later, Punto Hispano is the reference for the Spanish-speaking community.', founderExp: 'Over 12 years of experience', teamTitle: 'A Complete Team at Your Service', teamSubtitle: 'Everything under one roof.', teamStats: [{ number: '8+', text: 'Professionals on staff', sub: 'Administrators, lawyers, insurance advisors, language teachers' }, { number: '100%', text: 'Spanish-speaking team', sub: 'We understand each other. We speak your language and culture.' }, { number: '5+', text: 'Areas of expertise', sub: 'Administration, legal, insurance, languages, digital, relocation' }], missionTitle: 'Our Mission', missionWhat: 'What We Do Every Day', missionWhatDesc: 'Solve real problems. No generic services: we listen, understand, and resolve professionally.', missionWhere: 'Where We\'re Going', missionWhereDesc: 'That no one feels alone facing a problem. We want to be your first call.', allServices: 'Everything Punto Hispano Can Do for You', allServicesSub: 'Over 20 specific solutions.', commitmentsTitle: 'Three Commitments We Always Keep', commitments: [{ title: 'Response in Under 2 Hours', desc: 'During business hours, we respond within 2 hours maximum.', proof: 'Verifiable commitment' }, { title: 'First Consultation Free', desc: 'We listen and give you a clear diagnosis. No commitment.', proof: '100% free' }, { title: '4.9★ on Google', desc: 'Over 2,500 families have chosen and recommend us.', proof: 'Real client ratings' }], joinTitle: 'Want to Join the Team?', joinDesc: 'We\'re looking for passionate professionals.', joinCta: '✉️ Send us your CV →', finalTitle: 'Have a Problem in Switzerland? Tell Us.', finalDesc: 'You don\'t have to solve everything alone. Take the first step.', finalCta: 'Book Free Consultation →', finalServices: 'View All Services →' },
  zonesPage: { seoTitle: 'Service Zones | Punto Hispano - From Zurich for the Whole World', seoDesc: 'Administration, legal advice, insurance and more.', heroTitle: 'We Serve Your Zone', heroSubtitle: 'From Zurich, for the whole world. Administration, legal advice, insurance and more.', hq: 'Headquarters', switzerland: 'Switzerland', switzerlandDesc: 'With our office in Opfikon (Zurich), we serve the entire community in Switzerland.', countriesTitle: 'Countries with Greatest Presence', countriesSubtitle: 'Find our services in Switzerland, Spain, Italy and Latin America.', cities: 'cities', notFoundTitle: 'Can\'t find your zone?', notFoundDesc: 'No matter where you are, we can help you online.', whatsappCta: 'Contact via WhatsApp', scheduleCta: 'Schedule Consultation' },
  blogPage: { seoTitle: 'Punto Hispano Blog | Guides for Life in Switzerland', seoDesc: 'Guides on taxes, permits, insurance and life in Switzerland.', heroTitle: 'Punto Hispano Blog — ', heroTitleAccent: 'Guides and Tips for Life in Switzerland', heroDesc: 'Everything you need to know to live, work and thrive in Switzerland.', all: 'All', readArticle: 'Read article', readTime: 'min read', noArticles: 'No articles available in this category.', newsletterTitle: '📬 Get Our Articles in Your Email', newsletterDesc: 'One email per week with what you need to know. No spam.', emailPlaceholder: 'Your email...', subscribe: 'Subscribe', noSpam: '🔒 No spam. Cancel anytime.' },
  blogPost: { home: 'Home', blog: 'Blog', author: 'Punto Hispano Team', minRead: 'min read', needHelpMobileTitle: 'Need Help With This?', needHelpMobileDesc: 'First consultation free. Our team can take care of this for you.', scheduleConsult: 'Book Consultation →', endCtaTitle: 'Want Us to Take Care of This for You?', endCtaDesc: 'You don\'t have to do it alone. Book your free consultation and we\'ll explain exactly how we can help.', endCtaButton: 'Book Free Consultation →', endCtaResponse: '⏰ Reply in under 2 hours during business hours', keepReading: 'Keep reading', backToBlog: 'Back to Blog', sidebarHelpTitle: 'Need Help?', sidebarHelpDesc: 'First consultation free. Our team can take care of this for you.', relatedArticles: 'Related articles', mobileStickyCta: 'Free consultation' },
  zonesDetail: {
    seoTitleCountry: 'Services in {country} | Punto Hispano - Support from Zurich',
    seoDescCountry: 'Administration, legal advice, insurance and languages in {country}. In-person and online support from Opfikon, Zurich.',
    seoTitleCity: 'Services in {city}, {country} | Punto Hispano',
    seoDescCity: 'Administration, legal advice, insurance and more in {city}. In-person and online support from Opfikon, Zurich.',
    citiesIn: 'Cities in {country}',
    findYourCity: 'Find your city and discover all available services.',
    cities: 'cities',
    featured: '★ Featured',
    noZones: 'No zones available in this country currently.',
    contactAnyway: 'Contact us anyway',
    dontSeeCity: "Can't find your city?",
    dontSeeCityDesc: "No matter where you are in {country}, we serve you online from Zurich.",
    contactWhatsApp: 'Contact via WhatsApp',
    allZones: 'All zones',
    servicesForIn: 'Services for Expats in {city}',
    servicesFullDesc: 'At Punto Hispano, we offer a full range of services in {city}. From administration and legal advice to insurance, language courses and digital solutions. Our main office is in Opfikon (Zurich), but we serve you online wherever you are.',
    needHelpIn: 'Need help in {city}?',
    remoteAttention: "Even if you're in {city}, we assist you as if you were in our Zurich office. Contact us today.",
    officeOpfikon: 'Office in Opfikon, Switzerland',
    inPersonAndOnline: 'In-person and online support',
    scheduleConsultation: 'Schedule Consultation',
    otherCitiesIn: 'Other cities in {country}',
    exploreMore: 'Explore more areas where we offer our services.',
    viewAllCitiesIn: 'View all cities in {country}',
    backTo: 'Back to {country}',
    allServices: 'All Our Services',
    servicesIn: 'Services in {zone}',
    availableFromOffice: 'Available in-person and online from our office in Opfikon, Zurich.',
    viewMore: 'Learn more',
    mainOffice: 'Main Office',
    onlineConsultation: 'Online Consultation',
    serviceGestoria: 'Administration',
    serviceGestoriaDesc: 'Taxes, permits, RAV',
    serviceLegal: 'Legal Advice',
    serviceLegalDesc: 'Contracts, visas, inheritance',
    serviceLanguages: 'Languages',
    serviceLanguagesDesc: 'German, English, certificates',
    serviceInsurance: 'Insurance',
    serviceInsuranceDesc: 'Health, life, 3rd pillar',
    serviceCarRental: 'Car Rental',
    serviceCarRentalDesc: 'Cars, vans',
    serviceHousing: 'Housing',
    serviceHousingDesc: 'Rooms, apartments, shared',
    serviceDigital: 'Digital',
    serviceDigitalDesc: 'Web, CRM, AI, automation',
    serviceRelocation: 'Relocation Pack',
    serviceRelocationDesc: 'All-inclusive to get started',
    howWeHelp: 'How We Help You',
    remotely: 'Remotely',
    remoteDesc: "Even if you're in {city}, we assist you as if you were in our Zurich office.",
    remoteDescGeneral: 'From Zurich, for the whole world. Professional support regardless of your location.',
    step1Title: 'Contact Us',
    step1Desc: 'Message us on WhatsApp, email or call. Response within 24h.',
    step2Title: 'Online Consultation',
    step2Desc: 'We schedule a video call to understand your situation and needs.',
    step3Title: 'Resolution',
    step3Desc: 'We handle everything remotely. You only sign the necessary documents.',
    benefit1: 'Response in 24h',
    benefit2: '+12 years experience',
    benefit3: 'Multilingual support',
    home: 'Home',
    zones: 'Zones',
    gestoriaAndAdvice: 'Administration & Advice in {city}',
    professionalServices: 'Professional services in {city}',
    servicesDescription: 'Administration, legal advice, insurance and more in {country}. Support from our office in Zurich.',
  },
  gestoriaPage: {
    seoTitle: 'Administration Services in Switzerland | Taxes, Permits, RAV | Punto Hispano',
    seoDesc: 'Administration services in Switzerland. RAV registration, tax declarations, official translations, company formation. Over 12 years of experience.',
    heroTitle: 'Administration Services in Switzerland',
    heroAccent: '— Taxes, Permits and RAV Support',
    heroDesc: 'Another year without understanding your tax return? Letters from RAV you can\'t answer? We take care of everything. You just receive the result.',
    heroCta: 'View All Services ↓',
    heroWhatsapp: 'Free Consultation via WhatsApp',
    badge1: '+2,500 families',
    badge2: 'Response < 2h',
    badge3: '12+ years',
    empathyTitle: 'Does This Sound Familiar?',
    empathy1: 'Tax deadline approaching and you don\'t understand the first line',
    empathy2: 'You receive letters from RAV in German and don\'t know what they\'re asking',
    empathy3: 'You need to renew your permit and are afraid of rejection',
    empathy4: 'You want to start a business but Swiss paperwork paralyses you',
    empathyBottom: 'If you identify with any of these, you\'re in the right place.',
    categoriesTitle: 'What Do You Need to Solve?',
    categoriesDesc: 'Choose your situation and we\'ll show you exactly how we can help.',
    packagesTitle: 'All-in-One Packages',
    packagesDesc: 'Complete solutions for specific situations.',
    requestPack: 'Request Package',
    processTitle: 'That Simple',
    step1Title: 'Tell us your case',
    step1Desc: 'Write to us on WhatsApp or fill in the form',
    step2Title: 'Receive your plan',
    step2Desc: 'We tell you what you need and how much it costs',
    step3Title: 'We take care of it',
    step3Desc: 'You give us the documents, we do the rest',
    ctaTitle: 'Not Sure Which Service You Need?',
    ctaDesc: 'Tell us your situation and we\'ll tell you exactly what you need. Free and no obligation.',
    ctaWhatsapp: 'Free Consultation via WhatsApp',
    ctaSchedule: 'Schedule a Call',
    faqTitle: 'Frequently Asked Questions',
    faq1Q: 'How much does RAV registration cost?',
    faq1A: 'Write to us on WhatsApp or fill in our contact form and we\'ll send you a personalised quote within 2 hours. The RAV Registration Pack includes all documentation, Swiss-format CV, cover letter, JOB-room registration and accompaniment to your first appointment.\n\n⚠️ Remember: you must register BEFORE your first day without work.',
    faq2Q: 'How can I file my tax return?',
    faq2A: 'You can do it yourself or hire our tax return service. We review your complete situation, apply ALL possible deductions and file it on time.\n\n⚠️ Deadline: in most cantons, the deadline is 31 March.',
    faq3Q: 'Is the first consultation free?',
    faq3A: 'Yes. We offer a free 15-minute initial consultation where we listen to your case and identify what you need. You can visit our office in Opfikon, call us or write to us on WhatsApp. No obligation.',
    faqMore: 'More questions? Contact us →',
    reviewsTitle: 'What Our Clients Say',
    reviewsDesc: 'Real experiences from Spanish-speaking families',
    reviewsMore: 'View all reviews on Google →',
    crossSellTitle: 'Discover Our Other Services',
    crossSellDesc: 'Everything a Spanish speaker needs in Switzerland, under one roof.',
    finalTitle: 'Stop Worrying. Start Today.',
    finalDesc: 'Every day without resolving your paperwork is another day of stress.',
    finalCta: 'Free Consultation via WhatsApp',
    finalBack: 'View Services ↑',
  },
  homeSeo: {
    title: 'Punto Hispano | Administration, Legal & Relocation in Switzerland',
    description: 'Lost with paperwork in Switzerland? +2500 Spanish speakers have recovered their peace of mind. Taxes, permits, insurance, housing and more — all in your language.',
    skipButton: 'View full website',
  },

  legalPage: {
    seoTitle: 'Legal Advice for Spanish Speakers in Switzerland | Punto Hispano',
    seoDesc: 'Legal advice in Spanish in Switzerland. Immigration, labor, family, corporate, real estate law. Free first consultation.',
    heroTitle: 'Legal Advice for Spanish Speakers in Switzerland',
    heroAccent: '— Permits, Labor, Family & Business in Spanish',
    heroDesc: 'Problems with your permit, unfair dismissal, divorce, debts... You don\'t have to solve it alone. We advise you in Spanish with specialists in Swiss law.',
    heroCta: 'View Practice Areas ↓',
    heroWhatsapp: 'Free Consultation via WhatsApp',
    badge1: '+2,500 families',
    badge2: 'Response < 2h',
    badge3: '12+ years',
    empathyTitle: 'Does Any of This Sound Familiar?',
    empathy1: 'You\'ve been fired and think it\'s unfair but don\'t know what to do',
    empathy2: 'You\'re going through a divorce and don\'t understand Swiss law',
    empathy3: 'Your permit was denied and you don\'t know how to appeal',
    empathy4: 'Your landlord raised the rent and you don\'t know if it\'s legal',
    empathyBottom: 'If you identify with any, you\'re in the right place.',
    categoriesTitle: 'Our Legal Practice Areas',
    categoriesDesc: 'Choose your situation and we\'ll show you how we can help.',
    cat1Name: 'Immigration & Permits',
    cat1Desc: 'B, C, G permits, renewals, family reunification, denial appeals, Swiss citizenship.',
    cat1Badge: '7 services available',
    cat2Name: 'Labor Law',
    cat2Desc: 'Dismissals, contracts, claims, mobbing, work certificates, overtime, employer bankruptcy.',
    cat2Badge: '8 services available',
    cat3Name: 'Family Law',
    cat3Desc: 'Divorces, custody, alimony, property separation, mediation, child reunification.',
    cat3Badge: '7 services available',
    cat4Name: 'Corporate & Business Law',
    cat4Desc: 'Company formation, contracts, partner disputes, debt collection, insurance claims.',
    cat4Badge: '6 services available',
    cat5Name: 'Real Estate & Tax',
    cat5Desc: 'Buy/sell, rentals, landlord disputes, tax optimization, tax appeals.',
    cat5Badge: '6 services available',
    viewServices: 'View services →',
    ctaTitle: 'Not Sure Which Legal Area You Need?',
    ctaDesc: 'Tell us your situation and we\'ll guide you for free. No obligation.',
    ctaWhatsapp: 'Free Consultation via WhatsApp',
    ctaSchedule: 'Schedule a Call',
    processTitle: 'It\'s That Easy',
    step1: 'Tell us your case',
    step2: 'Receive your legal plan',
    step3: 'We take care of it',
    faqTitle: 'Frequently Asked Questions',
    faqMore: 'View more questions →',
    reviewsTitle: 'What Our Clients Say',
    crossSellTitle: 'Discover Our Other Services',
    crossSellDesc: 'Everything a Spanish speaker needs in Switzerland, under one roof.',
    finalTitle: 'Need Legal Advice?',
    finalDesc: 'Free first consultation with our Swiss law specialists.',
    finalCta: 'Request Free Consultation',
  },

  idiomasPage: {
    seoTitle: 'Language Training for Spanish Speakers in Switzerland | Punto Hispano',
    seoDesc: 'German and English courses designed for Spanish speakers. In-person and online classes in Zurich.',
    heroTitle: 'Language Training for Spanish Speakers in Switzerland',
    heroAccent: '— German, English & Official Certifications',
    heroDesc: 'From the best schools in Zurich with methodology designed for Spanish speakers. Learn faster, with less frustration, and get certified with guarantee.',
    heroCta: 'View Courses ↓',
    badge1: '+450 students',
    empathyTitle: 'Does Any of This Sound Familiar?',
    empathy1: 'You don\'t understand anything at the office and everything is in German',
    empathy2: 'You need B1 for the C permit and don\'t know where to start',
    empathy3: 'Your boss requires professional English and you freeze in meetings',
    empathy4: 'You want to get certified but official exams scare you',
    empathyBottom: 'If you identify with any, you\'re in the right place.',
    coursesTitle: 'What Do You Want to Learn?',
    coursesDesc: 'Choose your goal and we\'ll show you the fastest path.',
    germanTitle: 'German Courses',
    germanDesc: 'In-person and online. Group and private classes. From A1 to C1, with methodology adapted for Spanish speakers.',
    germanBadge: 'In-person · Online · Private',
    germanCta: 'View German courses →',
    englishTitle: 'English Courses',
    englishDesc: 'In-person and online. Group and private classes. Business English, conversation and certification prep.',
    englishBadge: 'In-person · Online · Private',
    englishCta: 'View English courses →',
    processTitle: 'It\'s That Easy',
    step1Title: 'Take your level test',
    step1Desc: 'We assess your current level in a call or with our form',
    step2Title: 'Choose your course',
    step2Desc: 'We recommend the ideal program for your goals',
    step3Title: 'Start speaking',
    step3Desc: 'From the first class you practice real conversation',
    ctaTitle: 'Not Sure Which Course You Need?',
    ctaDesc: 'Take your free level test and we\'ll recommend the perfect program.',
    ctaWhatsapp: 'Contact Us via WhatsApp',
    faqTitle: 'Frequently Asked Questions',
    faqMore: 'More questions? Write to us →',
    reviewsTitle: 'What Our Students Say',
    reviewsDesc: 'Real experiences from Spanish speakers who learned with us',
    reviewsMore: 'View all reviews on Google →',
    crossSellTitle: 'Discover Our Other Services',
    crossSellDesc: 'Everything a Spanish speaker needs in Switzerland, under one roof.',
    finalTitle: 'Ready to Master the Language?',
    finalDesc: 'Every week without learning is a missed opportunity.',
    finalCta: 'Free Trial Class',
  },

  segurosPage: {
    seoTitle: 'Health Insurance in Spanish in Switzerland | LAMal | Third Pillar | Punto Hispano',
    seoDesc: 'Insurance consulting in Spanish in Switzerland. Mandatory health insurance LAMal, third pillar, pensions. Free advice. Save up to 30%.',
    heroTitle: 'Insurance & Pensions for Spanish Speakers in Switzerland',
    heroAccent: '— LAMal, Third Pillar & Savings in Spanish',
    heroDesc: '70% of Spanish speakers in Switzerland pay more than necessary for health insurance. We analyze your policy, find savings and manage the complete switch.',
    heroCta: 'View All Services ↓',
    heroWhatsapp: 'Free Consultation via WhatsApp',
    breadServices: 'Services',
    breadSeguros: 'Insurance & Pensions',
    badge1: 'CICERO No. 31700',
    badge2: 'FINMA No. F014686595',
    badge3: '+20,000 people insured in 5 years',
    empathyTitle: 'Does Any of This Sound Familiar?',
    empathy1: 'You haven\'t reviewed your third pillar in years and don\'t know if you\'re losing money',
    empathy2: 'Your family grew but your insurance stayed the same',
    empathy3: 'You receive letters from your insurer in German and don\'t understand what they\'re asking',
    empathy4: 'You pay over 400 CHF/month for health insurance and don\'t know if it\'s necessary',
    empathyBottom: 'If you identify with any, you\'re in the right place.',
    servicesTitle: 'What Do You Need to Protect?',
    servicesDesc: 'Choose your situation and we\'ll show you how to save without losing coverage.',
    processTitle: 'It\'s That Easy',
    step1Title: 'Tell us your situation',
    step1Desc: 'Tell us what insurance you have and how much you pay',
    step2Title: 'We compare for you',
    step2Desc: 'We analyze all options in the Swiss market',
    step3Title: 'You save effortlessly',
    step3Desc: 'We manage the complete switch. You just sign',
    ctaTitle: 'Are You Paying Too Much for Insurance?',
    ctaDesc: 'Send us your current policy and in 24h we\'ll tell you how much you can save. Free, no obligation.',
    ctaWhatsapp: 'Free Consultation via WhatsApp',
    ctaSchedule: 'Schedule a Call',
    faqTitle: 'Frequently Asked Questions',
    faqMore: 'More questions? Write to us →',
    reviewsTitle: 'What Our Clients Say',
    reviewsDesc: 'Real experiences from families who saved with us',
    reviewsMore: 'View all reviews on Google →',
    crossSellTitle: 'Discover Our Other Services',
    crossSellDesc: 'Everything a Spanish speaker needs in Switzerland, under one roof.',
    finalTitle: 'Stop Overpaying. Start Saving Today.',
    finalDesc: 'Every month without reviewing your insurance is money lost.',
    finalCta: 'Free Consultation via WhatsApp',
    finalBack: 'View Services ↑',
  },

  digitalPage: {
    seoTitle: 'Advanced Digital Solutions - Web Development, CRM, AI & Marketing | Punto Hispano',
    seoDesc: 'Complete digital transformation for businesses in Switzerland: professional web development, intelligent CRM, AI chatbots, process automation and digital marketing.',
    seoKeywords: 'digital solutions switzerland, professional web development, business CRM, artificial intelligence, chatbots, process automation, digital marketing, SEO switzerland',
    reviewsTitle: 'WHAT OUR',
    reviewsAccent: 'CLIENTS SAY',
    reviewsDesc: 'Real experiences from companies that trust Punto Hispano',
  },

  emprendeDigitalPage: {
    seoTitle: 'Digital Solutions for Businesses | Web, CRM, AI | Punto Hispano',
    seoDesc: 'Complete catalog of digital services: web development, CRM, AI chatbots, automation, digital marketing.',
    backLink: 'Back to Emprende',
    badge: 'Service Catalog',
    title: 'Digital Solutions',
    subtitle: 'Complete technology services to grow your business in the digital world. From web development to artificial intelligence.',
    webTitle: 'Web Development',
    webDesc: 'Modern, fast websites optimized to convert visitors into clients.',
    ecommerceTitle: 'E-commerce / Online Store',
    ecommerceDesc: 'Complete online stores with product management, payments and shipping.',
    appTitle: 'Mobile Applications',
    appDesc: 'Native or hybrid apps for iOS and Android with premium experience.',
    chatbotTitle: 'AI Chatbots',
    chatbotDesc: 'Automate customer service 24/7 with artificial intelligence.',
    automationTitle: 'Process Automation',
    automationDesc: 'Optimize your workflows and save time on repetitive tasks.',
    marketingTitle: 'Digital Marketing',
    marketingDesc: 'Marketing strategies that generate measurable results.',
    whatIncludes: 'What\'s included?',
    additionalTitle: 'Additional Services',
    additionalDesc: 'Complement your project with these specialized services.',
    customDev: 'Custom Development',
    customDevDesc: 'Personalized software for your needs',
    graphicDesign: 'Graphic Design',
    graphicDesignDesc: 'Logos, branding and corporate materials',
    seoAudit: 'SEO Audit',
    seoAuditDesc: 'Complete analysis of your online presence',
    emailMarketing: 'Email Marketing',
    emailMarketingDesc: 'Automated email campaigns',
    socialMedia: 'Social Media',
    socialMediaDesc: 'Management and content for social networks',
    techConsulting: 'Tech Consulting',
    techConsultingDesc: 'Technology and digital transformation advisory',
    ctaTitle: 'Need something different?',
    ctaDesc: 'If you can\'t find exactly what you\'re looking for, tell us your idea and we\'ll create a custom solution for you.',
    ctaSend: 'Submit My Project',
    ctaConsult: 'Free Consultation',
  },

  viviendasPage: {
    seoTitle: 'Room Rental in Switzerland | Punto Hispano',
    seoDesc: 'Furnished rooms in Switzerland with WiFi, heating and services included. Flexible contracts. Spanish-speaking support.',
    badgeLoading: 'Loading...',
    badgeAvailable: 'accommodations available',
    badgeComingSoon: 'New accommodations coming soon',
    heroTitle: 'Find your home in Switzerland',
    heroDesc: 'Furnished rooms and apartments for Spanish speakers. All inclusive, flexible contracts, Spanish support.',
    where: 'Where?',
    allCities: 'All cities',
    checkIn: 'Check-in',
    checkOut: 'Check-out',
    guests: 'Guests',
    guestsAny: 'Any',
    guestsPerson: 'person',
    guestsPersons: 'persons',
    guestsPlus: '4+ persons',
    search: 'Search',
    insurance: 'Full insurance',
    noDeposit: 'No deposit',
    freeCancellation: 'Free cancellation',
    wifiIncluded: 'WiFi included',
    wifiDesc: 'High-speed internet',
    waterIncluded: 'Water included',
    waterDesc: 'No additional charges',
    heating: 'Heating',
    heatingDesc: 'Full climate control',
    spanishSupport: 'Spanish support',
    spanishSupportDesc: 'Personalized attention',
    filterAll: 'All',
    filterRoom: 'Room',
    filterDouble: 'Double',
    filterStudio: 'Studio',
    filterApartment: 'Full apartment',
    sortRecommended: 'Recommended',
    sortPriceAsc: 'Price: low to high',
    sortPriceDesc: 'Price: high to low',
    sortNewest: 'Newest',
    searching: 'Searching...',
    showing: 'Showing',
    accommodations: 'accommodations',
    noAccommodations: 'No accommodations available now',
    sortBy: 'Sort by:',
    whyChooseUs: 'Why choose us?',
    bestOption: 'The best option for Spanish speakers in Switzerland',
  },

  vehiculosPage: {
    seoTitle: 'Vehicle Rental in Switzerland | Price Comparator | Punto Hispano',
    seoDesc: 'Compare and book rental cars in Switzerland. Full insurance, unlimited mileage and Spanish-speaking support.',
    badgeText: 'Rental Comparator',
    heroTitle: 'Find your ideal vehicle',
    heroDesc: 'Compare prices and book online. Insurance included, unlimited mileage and Spanish-speaking support.',
    trustInsurance: 'Full insurance, no excess',
    trustKm: 'Unlimited mileage included',
    trustGps: 'GPS and 24/7 assistance',
    trustSpanish: '100% Spanish-speaking support',
    loading: 'Loading...',
    loadingFleet: 'Loading available fleet...',
    errorTitle: 'Error loading vehicles',
    errorDesc: 'Please try again later',
    showing: 'Showing',
    vehiclesAvailable: 'vehicles available',
    noVehiclesTitle: 'No vehicles for these dates',
    noVehiclesDesc: 'Try changing your search dates or select another pickup location.',
    changeDates: 'Change dates',
    clearFilters: 'Clear filters',
    needHelp: 'Need personalised help?',
    contactWhatsapp: 'Contact via WhatsApp',
    filters: 'Filters',
    ctaTitle: 'Ready to rent your car?',
    ctaDesc: 'Book now with unlimited mileage, GPS included and full insurance.',
    ctaWhatsapp: 'Book via WhatsApp',
    ctaContact: 'Contact Form',
  },

  relocationPage: {
    seoTitle: 'Relocation Pack Switzerland | Emigrate Without Risks | Punto Hispano',
    seoDesc: 'Comprehensive relocation service to Switzerland. Verified housing, complete paperwork, in-person support. From 349 CHF.',
    seoKeywords: 'relocation switzerland, emigrate switzerland, moving switzerland, relocation pack, punto hispano',
    breadHome: 'Home',
    breadServices: 'Services',
    breadRelocation: 'Relocation Pack',
    badge1: '100% Success',
    badge2: '+50 Families',
    badge3: '+10 Years',
    heroTitle: 'Emigrate to Switzerland',
    heroAccent: 'Without Risks',
    heroDesc: 'The only consultancy that guarantees verified housing, complete documentation and support from before your arrival to full integration.',
    heroCta: 'View Packs',
    heroWhatsapp: 'Free Consultation',
    empathyTitle: 'Does This Sound Familiar?',
    empathyDesc: 'Emigrating is exciting, but it can also be overwhelming',
    empathy1Title: 'Arriving without knowing where to start',
    empathy1Desc: 'You don\'t speak the language, don\'t know the system and every procedure feels like a maze.',
    empathy2Title: 'Fear of housing scams',
    empathy2Desc: 'Ghost agencies, lost deposits and abusive contracts are more common than you think.',
    empathy3Title: 'Papers you don\'t understand',
    empathy3Desc: 'Permit B, mandatory insurance, municipal registration... all in German, French or Italian.',
    empathy4Title: 'Feeling alone upon arrival',
    empathy4Desc: 'No support network, not knowing who to ask or where to go when something goes wrong.',
    empathyBottom: 'If any of this sounds familiar, you\'re not alone.',
    empathyBottomBold: 'More than 50 families',
    empathyBottomEnd: 'already emigrated with us without going through any of this.',
    packsTitle: 'Relocation Packages',
    packsDesc: 'Choose the perfect package for your move to Switzerland',
    packMostSold: '⭐ Best Seller',
    processTitle: 'It\'s That Easy',
    step1Title: 'Tell us your situation',
    step1Desc: 'We do a free assessment to understand what you need and which pack suits you best.',
    step2Title: 'We prepare everything',
    step2Desc: 'Documentation, verified housing, insurance and paperwork: we have everything ready before your arrival.',
    step3Title: 'You arrive and enjoy',
    step3Desc: 'We accompany you in person on the first day and provide extended support until you\'re integrated.',
    faqTitle: 'Frequently Asked Questions',
    crossSellTitle: 'Complementary Services',
    finalTitle: 'Ready to take the step?',
    finalDesc: 'More than 50 families already emigrated with our help.',
    finalCta: 'Start your Relocation',
  },

  emprendePage: {
    seoTitle: 'Start Your Digital Business | Web Development & Digital Solutions | Punto Hispano',
    seoDesc: 'Boost your digital business: web development, CRM, AI, automation and marketing. Tell us your idea and we make it happen.',
    badge: 'Digital Solutions',
    heroTitle1: 'Boost Your',
    heroTitle2: ' Digital Business',
    heroDesc: 'Web development, artificial intelligence, automation and digital marketing. We transform your ideas into technology solutions that deliver results.',
    ctaIdea: 'Tell Us Your Idea',
    ctaSolutions: 'View Solutions',
    servicesTitle: 'Our Digital Services',
    servicesDesc: 'Complete technology solutions to grow your business in the digital world.',
    svc1Title: 'Web Development', svc1Desc: 'Modern, fast websites optimised to convert visitors into clients.', svc1F1: 'Responsive design', svc1F2: 'SEO included', svc1F3: 'Integrated CMS',
    svc2Title: 'AI Chatbots', svc2Desc: 'Automate customer service 24/7 with advanced artificial intelligence.', svc2F1: 'Natural responses', svc2F2: 'Multi-language', svc2F3: 'CRM integration',
    svc3Title: 'Automation', svc3Desc: 'Optimise your business processes and save time on repetitive tasks.', svc3F1: 'Workflows', svc3F2: 'Integrations', svc3F3: 'Automated reports',
    svc4Title: 'Mobile Apps', svc4Desc: 'Native or hybrid applications for iOS and Android.', svc4F1: 'Premium UI/UX', svc4F2: 'Push notifications', svc4F3: 'Offline mode',
    svc5Title: 'Digital Marketing', svc5Desc: 'Marketing strategies that generate measurable results.', svc5F1: 'SEO & SEM', svc5F2: 'Social Media', svc5F3: 'Email Marketing',
    svc6Title: 'E-commerce', svc6Desc: 'Complete online stores with payment gateways and inventory management.', svc6F1: 'Secure payments', svc6F2: 'Stock management', svc6F3: 'Automated shipping',
    processTitle: 'How We Work',
    processDesc: 'A clear and transparent process from your idea to the final product.',
    proc1: 'Tell us your idea', proc1Desc: 'Describe your project and goals. It doesn\'t matter if it\'s just an initial idea.',
    proc2: 'Analysis and proposal', proc2Desc: 'We evaluate technical feasibility and present a detailed proposal.',
    proc3: 'Development', proc3Desc: 'We build your solution with agile methodologies and incremental deliveries.',
    proc4: 'Launch', proc4Desc: 'We deploy your project and accompany you through the launch.',
    card1Title: 'Share Your Idea', card1Desc: 'Have a project in mind? Tell us and we\'ll make it happen.', card1Cta: 'Submit Idea',
    card2Title: 'Earn Money Online', card2Desc: 'Learn to monetise your skills and create digital income.', card2Cta: 'View Guides',
    card3Title: 'Collaborate With Us', card3Desc: 'Join our partners and collaborators programme.', card3Cta: 'Become Partner',
    finalTitle: 'Ready to Digitise Your Business?',
    finalDesc: 'Contact us today and discover how we can help you grow in the digital world.',
    finalWhatsapp: 'Contact via WhatsApp',
    finalSchedule: 'Schedule Consultation',
  },

  politicasPage: {
    seoTitle: 'Policies & Legal Documents | Punto Hispano',
    seoDesc: 'Legal documentation, privacy policies, cookies and terms of use of Punto Hispano.',
    title: 'Policies & Legal Documents',
    subtitle: 'Transparency and regulatory compliance in all our services',
    commitmentTitle: 'Transparency Commitment',
    commitmentDesc: 'At Punto Hispano we are committed to maintaining full transparency about how we operate, how we process your data and what rights you have as a user of our services.',
    avisoLegal: 'Legal Notice',
    avisoLegalDesc: 'Information about the entity that owns this website, general conditions of use and intellectual property rights.',
    privacidad: 'Privacy Policy',
    privacidadDesc: 'Detailed information on how we collect, use, share and protect your personal data.',
    cookies: 'Cookie Policy',
    cookiesDesc: 'Information about which cookies we use, what they are for and how you can configure your preferences.',
    gdpr: 'GDPR Policy',
    gdprDesc: 'Complete information on personal data protection under the GDPR and your rights as a user.',
    questionTitle: 'Do you have any additional questions?',
    questionDesc: 'If you have any questions about our policies, contact our Data Protection Officer at',
    lastUpdate: 'Last update of our policies: 5 May 2025',
  },

  faqPage: {
    seoTitle: 'Frequently Asked Questions | Punto Hispano',
    seoDesc: 'Answers to the most frequently asked questions about our administration, legal, language, translation, web design, insurance and digital services in Switzerland.',
    title: 'Frequently Asked Questions',
    subtitle: 'Answers to the most common queries about our services',
    notFound: 'Can\'t find an answer to your question? Don\'t hesitate to contact us.',
    phone: 'Phone',
    email: 'Email',
    cat1: 'General',
    cat2: 'Administration & Management',
    cat3: 'Legal Advice',
    cat4: 'Language Courses',
    cat5: 'Official Translations',
    cat6: 'Web Design & Hosting',
    cat7: 'Insurance Consulting',
    cat8: 'Digital Solutions',
    q1_1: 'What services does Punto Hispano offer?',
    a1_1: 'Punto Hispano offers a wide range of professional services for the Spanish-speaking community in Switzerland, including administration, legal advice, language courses, official translations, web design, insurance consulting and advanced digital solutions.',
    q1_2: 'In which languages do you offer your services?',
    a1_2: 'Our services are primarily available in Spanish, but we also serve in German, English and Italian depending on the client\'s needs.',
    q1_3: 'How can I request a quote for a service?',
    a1_3: 'You can request a quote through our contact form, by calling +41 77 231 72 88 or by emailing info@puntohispano.ch.',
    q1_4: 'Do you have customised services for businesses?',
    a1_4: 'Yes, we offer customised solutions for businesses across all our service areas, adapting to each business\'s specific needs.',
    q1_5: 'Where is your main office located?',
    a1_5: 'Our main office is located at Thurgauerstrasse 117, 8152 Opfikon, Zurich, Switzerland. We attend by appointment.',
    q2_1: 'What does the company creation service include?',
    a2_1: 'Our company creation service includes advice on the most suitable legal form, document preparation, commercial register, tax registration and social security procedures.',
    q2_2: 'How does tax planning work?',
    a2_2: 'We carry out a personalised analysis of your tax situation, identify optimisation opportunities and advise on deductions and tax benefits applicable under Swiss law.',
    q2_3: 'Can you manage my tax return?',
    a2_3: 'Yes, we offer complete tax return management services for individuals.',
    q3_1: 'What documents do I need for family reunification?',
    a3_1: 'Family reunification generally requires: applicant\'s residence permit, legalised marriage/birth certificates, proof of sufficient financial means, rental contract proving adequate space, and sometimes language certificates.',
    q3_2: 'Do you offer advice on Swiss labour law?',
    a3_2: 'Yes, we provide comprehensive advice on Swiss labour law, including contract reviews, working conditions, dismissals, compensation and labour disputes.',
    q4_1: 'What is the price of German courses?',
    a4_1: 'Prices vary by level, modality and duration. We offer options from CHF 40 per hour in group classes to CHF 90 per session for private classes.',
    q4_2: 'Can I have a trial class before enrolling?',
    a4_2: 'Yes, we offer a free trial class so you can get to know our methodology and assess the level that best suits you.',
    q5_1: 'Are your translations valid for official procedures?',
    a5_1: 'Yes, our official translations are carried out by sworn translators and are valid for submission to official bodies both in Switzerland and abroad.',
    q5_2: 'How long does a sworn translation take?',
    a5_2: 'Standard documents usually take 2-3 business days. We also offer express services for urgent documents.',
    q6_1: 'What does the professional website package include?',
    a6_1: 'It includes: custom design of 5-7 pages, responsive design, basic SEO, Analytics integration, contact form, one year of hosting and 3 months of maintenance.',
    q6_2: 'Can I update my website on my own afterwards?',
    a6_2: 'Yes, we implement a CMS that allows you to update text, images and sections easily. We also offer basic training.',
    q7_1: 'How can I reduce my health insurance premium?',
    a7_1: 'There are several strategies: adjusting the deductible, choosing an HMO model, checking if you qualify for cantonal subsidies, or combining different coverages.',
    q7_2: 'What insurance is mandatory in Switzerland?',
    a7_2: 'Basic health insurance (KVG/LAMal) is mandatory for all residents. For vehicle owners, liability insurance is also mandatory.',
    q8_1: 'What is a CRM and how can it benefit my business?',
    a8_1: 'A CRM allows you to manage customer relationships centrally. Benefits include better data organisation, sales process automation and behaviour analysis.',
    q8_2: 'What AI solutions do you offer for small businesses?',
    a8_2: 'We offer chatbots for 24/7 support, administrative task automation, predictive data analysis and virtual scheduling assistants.',
  },

  contactoPage: {
    seoTitle: 'Contact | Administration & Consulting in Switzerland | Punto Hispano',
    seoDesc: 'Write to us via WhatsApp or email or book an appointment in Zurich. Fast response.',
    heroTitle: "Let's Talk",
    heroDesc: 'Our team of bilingual professionals is ready to assist you. Choose your preferred contact method.',
    whatsappBtn: 'Direct WhatsApp',
    formBtn: 'Contact Form',
    formTitle: 'Contact Form',
    successTitle: 'Message Sent!',
    successDesc: 'Thank you for contacting us. We have received your message and will get back to you within 24 hours.',
    sendAnother: 'Send another message',
    labelName: 'Full Name',
    placeholderName: 'Enter your full name',
    labelEmail: 'Email Address',
    placeholderEmail: 'your.email@example.com',
    labelPhone: 'Phone (optional)',
    placeholderPhone: '+41 XX XXX XX XX',
    labelService: 'Service Area',
    selectService: 'Select an area',
    optGestoria: 'Administration & Tax',
    optLegal: 'Legal Advice',
    optIdiomas: 'Language Courses',
    optSeguros: 'Insurance & Pensions',
    optDigital: 'Digital Solutions',
    optOther: 'Other',
    labelMessage: 'Your Message',
    placeholderMessage: 'Tell us how we can help you...',
    sending: 'Sending message...',
    sendBtn: 'Send Message',
    toastSuccess: 'Form submitted',
    toastSuccessDesc: 'We have received your message. We will contact you soon.',
    toastError: 'Submission error',
    toastErrorDesc: 'There was a problem sending your message. Please try again.',
    infoTitle: 'Contact Information',
    infoDesc: 'Our multilingual team is ready to assist you in English, German and Spanish. Contact us through any of these channels.',
    officeTitle: 'Our Office',
    phoneTitle: 'Phone',
    whatsappTitle: 'Direct WhatsApp',
    emailTitle: 'Email',
    hoursTitle: 'Business Hours',
    monFri: 'Monday - Friday',
    sat: 'Saturday',
    sun: 'Sunday',
    closed: 'Closed',
    needHelp: 'Need immediate help?',
    needHelpDesc: 'Contact us directly via WhatsApp for quick assistance',
    validName: 'Name must be at least 2 characters',
    validEmail: 'Please enter a valid email address',
    validService: 'Please select a service area',
    validMessage: 'Message must be at least 10 characters',
  },

  contactoFormPage: {
    seoTitle: 'Contact Form | Punto Hispano',
    seoDesc: 'Contact us for inquiries about our services. We respond within 24-48 business hours.',
    title: 'Contact Form',
    subtitle: 'Complete the form below to send us your inquiry. Our team will get back to you as soon as possible.',
    successTitle: 'Message Sent!',
    successDesc: 'Thank you for contacting us. We have received your message and will respond within 24-48 business hours.',
    sendAnother: 'Send another message',
    labelName: 'Full name',
    placeholderName: 'Enter your name',
    labelEmail: 'Email address',
    labelPhone: 'Phone (optional)',
    placeholderPhone: 'Your phone number',
    labelService: 'Service area',
    selectService: 'Select an area',
    optGestoria: 'Administration',
    optLegal: 'Legal Advice',
    optIdiomas: 'Language Courses',
    optSeguros: 'Insurance & Pensions',
    optDigital: 'Digital Solutions',
    optCoches: 'Car Rental',
    optViviendas: 'Housing Rental',
    labelMessage: 'Message',
    placeholderMessage: 'How can we help you?',
    sending: 'Sending...',
    sendBtn: 'Send Message',
    privacyText: 'By submitting this form, you accept our',
    privacyLink: 'privacy policy',
    privacyEnd: 'and the processing of your data to respond to your inquiry.',
    fastResponse: 'Fast response',
    fastResponseDesc: '24-48 business hours',
    noCommitment: 'No commitment',
    noCommitmentDesc: 'Personalised quotes',
    spanishSupport: 'Multilingual support',
    spanishSupportDesc: 'Professional multilingual team',
  },

  oficinasPage: {
    seoTitle: 'Opfikon Office | Punto Hispano',
    seoDesc: 'Visit our office in Opfikon, Zurich. Location, hours, transport and how to find us.',
    heroTitle: 'Our Office in Opfikon',
    heroDesc: 'Visit us at the TMC commercial center, minutes from downtown Zurich. Our team will assist you personally.',
    howToFind: 'How to Find Us — Step by Step',
    step1Title: 'Look for the TMC building',
    step1Desc: 'It is a commercial center at Thurgauerstrasse 117. You will see the "TMC" sign on the façade.',
    step2Title: 'Enter and walk straight',
    step2Desc: 'Enter through the main door and walk straight until you see a café.',
    step3Title: 'Go up to the 1st floor',
    step3Desc: 'Next to the café you will find the elevator. Go up to the first floor.',
    step4Title: 'Turn right',
    step4Desc: 'When you exit the elevator, turn right. Our office is 181 — you will see the Punto Hispano logo.',
    tmcNote: 'We are inside the TMC (Trade Mart Center), a showroom and office building.',
    enlargeMap: 'Enlarge Map',
    addressTitle: 'Address',
    phoneTitle: 'Phone',
    emailTitle: 'Email',
    hoursTitle: 'Business Hours',
    appointmentsTitle: 'Appointments',
    appointmentsDesc: 'For better service, we recommend booking an appointment in advance.',
    requestAppointment: 'Request Appointment',
    howToGet: 'How to Get Here',
    train: 'Train',
    trainDesc: 'Opfikon station, 5 minutes walk',
    bus: 'Bus',
    busDesc: 'Lines 759, 781 - Thurgauerstrasse stop',
    car: 'Car',
    carDesc: 'Parking available in the building',
    airport: 'From airport',
    airportDesc: '10 minutes by taxi or direct bus',
    parkingTitle: 'Parking',
    parkingDesc: 'The TMC building has hourly parking for clients. Alternatively, there is public parking nearby.',
    additionalInfo: 'Additional Information',
    accessibilityTitle: 'Accessibility',
    accessibilityDesc: 'Our offices have access for people with reduced mobility. The building has elevators and ramps.',
    walkInsTitle: 'Walk-in visits',
    walkInsDesc: 'Although we recommend booking an appointment, we accept walk-ins based on availability.',
    nearbyTitle: 'Nearby services',
    nearbyDesc: 'Inside the TMC building you will find a café where you can wait comfortably.',
    otherContactTitle: 'Prefer to contact us another way?',
    otherContactDesc: 'If you cannot visit us in person, we have other contact options.',
    contactForm: 'Contact Form',
    whatsappChat: 'WhatsApp & Chat',
    days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
    satHours: '10:00 - 14:00 (by appointment)',
    closed: 'Closed',
  },

  quienesSomosPage: {
    seoTitle: 'About Us - Punto Hispano | Professional Services in Switzerland',
    seoDesc: 'Meet Punto Hispano: 12+ years helping communities in Switzerland. Administration, insurance, legal, languages and digital services.',
    badge: 'About Us',
    heroTitle: 'Punto Hispano:',
    heroAccent: 'Your bridge between Switzerland and the world',
    heroDesc: 'Since 2013, we facilitate integration and success in Swiss territory, combining local experience with deep cultural understanding.',
    stat1: 'Satisfied Clients',
    stat2: 'Procedures Completed',
    stat3: 'Companies Created',
    stat4: 'Years of Experience',
    missionBtn: 'Our Mission & Vision',
    contactBtn: 'Contact Us',
    teamPhoto: 'Our Team',
    teamPhotoDesc: 'Professionals committed to your success',
    historyTitle: 'Our History',
    historySubtitle: 'A path of growth and commitment',
    historyDesc: 'Learn how Punto Hispano evolved from its beginnings to become the reference for the community in Switzerland.',
    timeline2013Title: 'The beginnings',
    timeline2013Desc: 'Santiago Castillo, the founder, started in Switzerland with insurance and 3rd pillar.',
    timeline2019Title: 'Services without an office',
    timeline2019Desc: 'Punto Hispano began offering professional services to the community.',
    timeline2023Title: 'Office opening',
    timeline2023Desc: 'Punto Hispano opened its physical office, marking an important milestone.',
    timeline2025Title: 'Continued expansion',
    timeline2025Desc: 'We continue expanding our services, consolidating as the reference.',
    teamTitle: 'Our Team & Office',
    teamSubtitle: 'The people behind Punto Hispano',
    teamDesc: 'Meet Santiago Castillo, our founder, and the professional team.',
    founderBadge: 'Founder',
    valuesTitle: 'Our Values',
    valuesSubtitle: 'The principles that guide us',
    valuesDesc: 'Each value represents a real commitment to our clients and community.',
    val1Title: 'Closeness',
    val1Desc: 'Personalised attention adapted to each client.',
    val2Title: 'Professionalism',
    val2Desc: 'Rigour, excellence and continuous improvement.',
    val3Title: 'Transparency',
    val3Desc: 'Clear and honest communication.',
    val4Title: 'Innovation',
    val4Desc: 'Constantly seeking creative and efficient solutions.',
    val5Title: 'Commitment',
    val5Desc: 'Absolute dedication to client satisfaction and success.',
    val6Title: 'Integration',
    val6Desc: 'We bridge cultures.',
    ctaTitle: 'Ready to take the first step?',
    ctaDesc: 'Contact us today for a free consultation.',
    ctaBtn: 'Request Free Consultation',
    ctaSecondary: 'View Our Services',
  },

  misionVisionPage: {
    seoTitle: 'Mission & Vision - Punto Hispano | Leader in Professional Services in Switzerland',
    seoDesc: 'Discover the mission, vision and values of Punto Hispano: 12+ years leading professional services in Switzerland.',
    badge: 'Our Purpose',
    heroTitle: 'Mission &',
    heroAccent: 'Vision',
    heroDesc: 'Discover what drives us to be the reference in professional services in Switzerland',
    stat1: 'Satisfied clients',
    stat2: 'Years of experience',
    stat3: 'Quality commitment',
    stat4: 'Service pillars',
    missionTitle: 'Our Mission',
    missionSubtitle: 'What we do every day',
    missionText1: 'Provide comprehensive professional services of the highest quality to the community in Switzerland.',
    missionText2: 'We are committed to being a reliable bridge between cultures.',
    missionPoints: ['Comprehensive professional services', 'We facilitate integration in Switzerland', 'Professional development and personal well-being', 'Efficient and personalised solutions', 'Reliable bridge between cultures', 'Close support in your language'],
    commitmentTitle: 'Daily Commitment',
    commitmentDesc: 'Every day we work to make our mission a reality.',
    visionTitle: 'Our Vision',
    visionSubtitle: 'Where we are heading',
    visionText1: 'To be recognised as the leading company in professional services in Switzerland.',
    visionText2: 'We aspire to transform the client experience in Switzerland.',
    visionPoints: ['Leading company in services', 'Excellence and technological innovation', 'Human and personalised approach', 'Perfect integration of traditional and digital services', 'Complete solutions ecosystem', 'Client experience transformation'],
    futureTitle: 'Bright Future',
    futureDesc: 'We are building the future of professional services in Switzerland.',
    valuesTitle: 'Values that Define Us',
    valuesSubtitle: 'The fundamental principles that guide every decision.',
    val1Title: 'Closeness',
    val1Desc: 'Personal and human treatment',
    val2Title: 'Trust',
    val2Desc: 'Total transparency',
    val3Title: 'Excellence',
    val3Desc: 'Superior quality',
    val4Title: 'Innovation',
    val4Desc: 'Advanced technology',
    ctaTitle: 'Ready to be part of our story?',
    ctaDesc: 'Join over 2500 clients who trust Punto Hispano.',
    ctaBtn: 'Free Consultation',
    ctaSecondary: 'View Services',
  },

  valoresPage: {
    seoTitle: 'Corporate Values - Punto Hispano | Excellence, Trust & Innovation',
    seoDesc: 'Discover the fundamental values of Punto Hispano: excellence, trust, specialisation, integrity, innovation and empathy.',
    badge: 'Our Philosophy',
    heroTitle: 'Our',
    heroAccent: 'Values',
    heroDesc: 'The fundamental principles that define our identity and guide every decision.',
    stat1: 'Years of experience',
    stat2: 'Satisfied clients',
    stat3: 'Service pillars',
    stat4: 'Quality commitment',
    val1Title: 'Excellence',
    val1Desc: 'We seek the highest quality in every service, exceeding client expectations.',
    val2Title: 'Trust',
    val2Desc: 'We build lasting relationships based on transparency, honesty and fulfilment.',
    val3Title: 'Specialisation',
    val3Desc: 'We maintain deep and up-to-date knowledge of our service areas.',
    val4Title: 'Integrity',
    val4Desc: 'We act with professional rectitude and ethics in all our interactions.',
    val5Title: 'Innovation',
    val5Desc: 'We constantly incorporate new technologies and methods.',
    val6Title: 'Empathy',
    val6Desc: 'We understand the unique needs and circumstances of each client.',
    learnMore: 'Learn more',
    commitmentTitle: 'Our Unwavering Commitment',
    commitmentText1: 'At Punto Hispano, these values are not merely words on a web page, but living principles.',
    commitmentText2: 'We are firmly committed to maintaining the highest standards of quality and professional ethics.',
    promiseLabel: 'Our promise:',
    promiseText: 'Every day we work to be the reference of trust, excellence and closeness that the community in Switzerland deserves and needs.',
    meetTeam: 'Meet our team',
    actionTitle: 'Values in Action',
    actionSubtitle: 'Discover how our values translate into tangible benefits.',
    qualityTitle: 'Quality Guarantee',
    qualityDesc: 'Our commitment to excellence is reflected in every service we provide.',
    qualityItems: ['Personalised and dedicated attention', 'Continuous monitoring of all processes', 'Total transparency in our management'],
    closenessTitle: 'Human Closeness',
    closenessDesc: 'We understand that behind every procedure there is a person with unique dreams and needs.',
    closenessItems: ['Communication in your native language', 'Understanding of your culture and context', 'Emotional support in complex processes'],
  },

  carrerasPage: {
    seoTitle: 'Work With Us at Punto Hispano Switzerland',
    seoDesc: 'Discover career opportunities at Punto Hispano: administration, legal, languages, insurance and digital.',
    badge: 'Career Opportunities',
    heroTitle: 'Work With',
    heroAccent: 'Us',
    heroDesc: 'Join the leading team in professional services in Switzerland.',
    stat1: 'Satisfied clients',
    stat2: 'Years of experience',
    stat3: 'Professionals + external collaborators',
    stat4: 'Areas of specialisation',
    benefitsTitle: 'Why choose Punto Hispano?',
    benefitsSubtitle: 'Discover the advantages of being part of our professional team',
    ben1Title: 'Multicultural Environment',
    ben1Desc: 'Work in a collaborative environment with professionals from diverse nationalities',
    ben2Title: 'Professional Growth',
    ben2Desc: 'Real development and internal promotion opportunities',
    ben3Title: 'Continuous Training',
    ben3Desc: 'Support for certifications and constant professional development',
    ben4Title: 'Work-Life Balance',
    ben4Desc: 'Flexible hours and respect for your personal time',
    ben5Title: 'Social Benefits',
    ben5Desc: 'Health insurance, pension plans and additional benefits',
    ben6Title: 'Recognition',
    ben6Desc: 'Incentive system and recognition for exceptional performance',
    joinTitle: 'Join the Team',
    joinSubtitle: 'Your next professional opportunity awaits',
    joinText1: 'At Punto Hispano we seek committed talent with a positive attitude and service vocation.',
    joinText2: 'Be part of the leading company in professional services in Switzerland.',
    processTitle: 'Selection Process:',
    processSteps: ['Submit CV and cover letter', 'Application review and shortlisting', 'Initial interview with HR', 'Technical interview with the team', 'Job offer'],
    sendCV: 'Send your CV',
    areasTitle: 'Areas of Specialisation',
    areasSubtitle: 'Discover the different areas where you can develop your career',
    area1Title: 'Tax Administration',
    area1Desc: 'Specialists in tax returns, accounting and fiscal advice.',
    area1Req: 'Experience in Swiss/international taxation, business administration degree or similar.',
    area2Title: 'Legal Advice',
    area2Desc: 'Legal professionals specialised in immigration, labour, civil and commercial law.',
    area2Req: 'Law degree, experience in international legal advisory.',
    area3Title: 'Language Teaching',
    area3Desc: 'Native teachers for personalised and group classes.',
    area3Req: 'Official language teaching qualification, certifications (DELE, Goethe, Cambridge).',
    area4Title: 'Insurance Consulting',
    area4Desc: 'Advisors specialised in health, life insurance and retirement plans.',
    area4Req: 'Insurance advisor certification, experience in the Swiss market.',
    area5Title: 'Digital Development',
    area5Desc: 'Web designers and developers, UX/UI specialists and digital marketing.',
    area5Req: 'Technical background, project portfolio, up-to-date knowledge.',
    area6Title: 'Sales & Marketing',
    area6Desc: 'Professionals focused on client acquisition and positioning strategies.',
    area6Req: 'B2B commercial experience, exceptional communication skills.',
    reqLabel: 'Requirements:',
  },

  notFoundPage: {
    title: 'Page not found',
    desc: 'Sorry, the page you are looking for does not exist or has been moved.',
    goHome: 'Back to home',
  },

  recursosPage: {
    seoTitle: 'Free Resources | Guides, Tools & Webinars | Punto Hispano',
    seoDesc: 'Access free guides, calculators, webinars and resources for your success in Switzerland.',
    heroTitle: 'Resource Centre',
    heroSubtitle: 'Free tools, guides and materials for your success in Switzerland',
    searchPlaceholder: 'Search resources...',
    filterAll: 'All',
    filterGuides: 'Guides',
    filterCalculators: 'Calculators',
    filterWebinars: 'Webinars',
    filterVideos: 'Videos',
    filterTemplates: 'Templates',
    categoryAll: 'All categories',
    categoryLegal: 'Legal',
    categoryFiscal: 'Tax',
    categorySeguros: 'Insurance',
    categoryIdiomas: 'Languages',
    categoryDigital: 'Digital',
    sortPopular: 'Most popular',
    sortRecent: 'Most recent',
    sortRating: 'Top rated',
    downloads: 'downloads',
    pages: 'pages',
    downloadBtn: 'Download',
    previewBtn: 'Preview',
    featured: 'Featured',
    new: 'New',
    noResults: 'No resources found with the selected filters.',
    clearFilters: 'Clear filters',
    newsletterTitle: 'Want to receive new resources?',
    newsletterDesc: 'Subscribe and receive guides and tools directly to your email.',
    newsletterBtn: 'Subscribe',
    emailPlaceholder: 'your@email.com',
  },

  guiasPracticasPage: {
    seoTitle: 'Practical Guides | Resources | Punto Hispano',
    seoDesc: 'Detailed guides on procedures and processes in Switzerland.',
    title: 'Practical Guides',
    subtitle: 'Useful information for your procedures and processes',
    readTime: 'Reading time',
    readGuide: 'Read guide',
    faqTitle: 'Frequently Asked Questions about our Guides',
  },

  whitepapersPage: {
    seoTitle: 'Whitepapers | Professional Resources | Punto Hispano',
    seoDesc: 'Download our specialised whitepapers on taxation, law and digital transformation.',
    title: 'Whitepapers',
    subtitle: 'Technical documents and professional guides',
    pages: 'pages',
    published: 'Published',
    downloadPdf: 'Download PDF',
    faqTitle: 'Frequently Asked Questions about our Whitepapers',
  },

  videosWebinarsPage: {
    seoTitle: 'Videos & Webinars | Audiovisual Resources | Punto Hispano',
    seoDesc: 'Access our webinars and audiovisual content about procedures, taxes and life in Switzerland.',
    title: 'Videos & Webinars',
    subtitle: 'Educational and professional audiovisual content',
    upcoming: 'Upcoming',
    past: 'Past',
    register: 'Register',
    watchNow: 'Watch now',
    duration: 'Duration',
    faqTitle: 'Frequently Asked Questions about our Webinars',
  },

  colaboraPage: {
    seoTitle: 'Partner & Collaborator Programme | Punto Hispano',
    seoDesc: 'Join our partner programme: affiliates, tech partners and agencies.',
    heroTitle: 'Partner & Collaborator Programme',
    heroDesc: 'Join our ecosystem and grow together.',
    backToEmprende: 'Back to Emprende',
    whyPartner: 'Why become a Partner?',
    whyPartnerDesc: 'Exclusive benefits of joining our collaboration ecosystem.',
    ben1Title: 'Attractive Commissions',
    ben1Desc: 'Earn competitive commissions for each referral or joint project.',
    ben2Title: 'Dedicated Support',
    ben2Desc: 'Exclusive support team for partners with priority.',
    ben3Title: 'Continuous Training',
    ben3Desc: 'Access to exclusive resources and training for partners.',
    ben4Title: 'Joint Growth',
    ben4Desc: 'Grow your business alongside ours with real synergies.',
    ctaTitle: 'Ready to become our Partner?',
    ctaBtn: 'Request Partnership',
    ctaWhatsapp: 'Ask via WhatsApp',
  },

  ganaDineroPage: {
    seoTitle: 'Earn Money Online | Digital Strategies | Punto Hispano',
    seoDesc: 'Learn to monetise your skills and create digital income from Switzerland.',
    heroTitle: 'Earn Money Online',
    heroDesc: 'Proven strategies to generate income in the digital world.',
    backToEmprende: 'Back to Emprende',
    strategiesTitle: 'Strategies to Generate Income',
    strategiesDesc: 'Discover the best ways to earn money online.',
    tipsLabel: 'Key tips:',
    ctaTitle: 'Need help getting started?',
    ctaDesc: 'We advise you to launch your digital business.',
    ctaBtn: 'Free Consultation',
    ctaWhatsapp: 'WhatsApp',
  },

  transmiteIdeasPage: {
    seoTitle: 'Submit Your Project Idea | Punto Hispano',
    seoDesc: 'Tell us your digital project idea and we will help you make it a reality.',
    heroTitle: 'Tell Us Your Idea',
    heroDesc: 'Describe your project and our team will advise you on how to make it happen.',
    backToEmprende: 'Back to Emprende',
    formTitle: 'Describe your project',
    labelName: 'Full name',
    placeholderName: 'Your name',
    labelEmail: 'Email address',
    labelPhone: 'Phone (optional)',
    placeholderPhone: '+41 XX XXX XX XX',
    labelProjectType: 'Project type',
    labelDescription: 'Describe your idea',
    placeholderDescription: 'Tell us the details of your project...',
    labelBudget: 'Estimated budget',
    labelUrgency: 'Urgency',
    labelFeatures: 'Required features',
    submitBtn: 'Submit Idea',
    sending: 'Sending...',
    successTitle: 'Idea Received!',
    successDesc: 'We have received your proposal. We will contact you to evaluate your project.',
    sendAnother: 'Submit another idea',
    guaranteeTitle: 'Our commitment',
    guarantee1: 'Response in 24-48h',
    guarantee2: 'Free evaluation',
    guarantee3: 'No commitment',
    guarantee4: 'Detailed quote',
  },

  authPage: {
    loginTitle: 'Log In',
    loginDesc: 'Access your Punto Hispano account.',
    signupTitle: 'Create Account',
    signupDesc: 'Register to access all our services.',
    email: 'Email address',
    password: 'Password',
    confirmPassword: 'Confirm password',
    name: 'Full name',
    loginBtn: 'Log In',
    signupBtn: 'Create Account',
    forgotPassword: 'Forgot your password?',
    noAccount: "Don't have an account?",
    hasAccount: 'Already have an account?',
    signupLink: 'Sign up',
    loginLink: 'Log in',
    orContinueWith: 'Or continue with',
    google: 'Google',
    resetTitle: 'Reset Password',
    resetDesc: 'Enter your email and we will send you a reset link.',
    resetBtn: 'Send link',
    resetSuccess: 'We have sent a link to your email.',
    backToLogin: 'Back to login',
  },

  avisoLegalPage: {
    seoTitle: 'Legal Notice | Punto Hispano',
    seoDesc: 'Complete legal information about Punto Hispano and its services.',
    title: 'Legal Notice',
    subtitle: 'Complete legal information about Punto Hispano and our services',
    whatIs: 'What is this legal notice?',
    whatIsP1: 'This legal notice governs the use of the website www.puntohispano.ch, owned by Punto Hispano GmbH, a company registered in Switzerland.',
    whatIsP2: 'By browsing our website, you accept all the conditions set out herein. We recommend that you read this information carefully.',
    whoWeAre: 'Who are we?',
    idData: 'Identification data',
    company: 'Company',
    companySubtitle: 'Agency & Advisory in Switzerland',
    officialAddress: 'Official address',
    contactTitle: 'How to contact us?',
    digitalComm: 'Digital communication',
    directComm: 'Direct communication',
    mainEmail: 'Main email:',
    website: 'Website:',
    phone: 'Phone:',
    officeHours: 'Office hours:',
    weekdayHours: 'Monday to Friday: 9:00 - 18:00',
    saturdayHours: 'Saturdays: 10:00 - 14:00',
    termsTitle: 'Website terms of use',
    term1Title: '1. Acceptance of conditions',
    term1Desc: 'By accessing and using this website, you automatically agree to be bound by these terms of use. If you disagree with any of these conditions, we recommend that you do not use our site.',
    term2Title: '2. Permitted use',
    term2Desc: 'This website is intended exclusively for:',
    term2Items: ['Obtaining information about our services', 'Requesting consultations and quotes', 'Contacting our professional team', 'Accessing resources and documentation'],
    term3Title: '3. Prohibited use',
    term3Warning: 'It is strictly prohibited to:',
    term3Items: ['Use the site for illegal activities', 'Attempt to access restricted areas', 'Copy or reproduce content without authorisation', 'Send false or misleading information', 'Interfere with the operation of the site'],
    ipTitle: 'Intellectual and industrial property',
    ipProtected: 'What is protected?',
    ipDesc: 'All elements of this website are protected by Swiss intellectual and industrial property laws and applicable international regulations.',
    ipVisual: 'Visual elements',
    ipVisualItems: ['Design and layout', 'Logos and trademarks', 'Images and photographs', 'Icons and graphics'],
    ipTechnical: 'Technical elements',
    ipTechnicalItems: ['Programming code', 'Database', 'Web architecture', 'Features'],
    ipWarning: 'Reproduction, distribution, public communication, transformation or any other form of exploitation, in whole or in part, of the contents of this site without the express written authorisation of Punto Hispano is expressly prohibited.',
    responsibilityTitle: 'Responsibilities and limitations',
    ourCommitment: 'Our commitment',
    ourCommitmentDesc: 'Punto Hispano is committed to keeping this website operational and up to date. However, we cannot guarantee:',
    ourCommitmentItems: ['Continuous 24/7 website availability', 'Complete absence of technical errors', 'Compatibility with all browsers', 'Absolute protection against cyber attacks'],
    userResponsibility: 'User responsibility',
    userResponsibilityDesc: 'As a user of the website, you are responsible for:',
    userResponsibilityItems: ['Providing truthful and up-to-date information', 'Maintaining the confidentiality of your credentials', 'Using the site responsibly and legally', 'Respecting intellectual property rights'],
    lawTitle: 'Applicable law and jurisdiction',
    applicableLaw: 'Applicable law',
    applicableLawDesc: 'This legal notice is governed by Swiss law, specifically the laws of the Canton of Zurich and Swiss federal legislation.',
    jurisdiction: 'Competent jurisdiction',
    jurisdictionDesc: 'For any dispute that may arise in connection with the use of this website, the parties expressly submit to the jurisdiction of the courts of Zurich, Switzerland.',
    faqTitle: 'Frequently asked legal questions',
    faqMoreInfo: 'Need more specific legal information? Contact our experts for a personalised consultation',
    relatedPolicies: 'Related policies',
    dataProtection: 'Data Protection',
    dataProtectionDesc: 'Learn how we protect your personal information',
    cookiePolicyLink: 'Cookie Policy',
    cookiePolicyDesc: 'Information about cookie usage',
    privacyPolicyLink: 'Privacy Policy',
    privacyPolicyDesc: 'General privacy terms',
    legalQuestions: 'Legal questions?',
    legalQuestionsDesc: 'If you have questions about this legal notice or need clarification on our terms of use, do not hesitate to contact us.',
    lastUpdated: 'Last updated:',
    lastUpdatedDate: '24 June 2025',
  },
  politicaPrivacidadPage: {
    seoTitle: 'Privacy Policy | Personal Data Protection | Punto Hispano',
    seoDesc: 'Punto Hispano\'s comprehensive privacy policy. Learn how we collect, use and protect your personal information following data-protection best practices.',
    titlePart1: 'Privacy',
    titlePart2: 'Policy',
    subtitle: 'Your privacy is fundamental. Learn how we protect your personal information with the highest security standards.',
    gdprBadge: 'GDPR Compliant',
    encryptionBadge: 'AES-256 Encryption',
    isoBadge: 'ISO 27001',
    introTitle: 'Why is your privacy important?',
    introP1Pre: 'At',
    introP1Brand: 'Punto Hispano',
    introP1Post: ', we value and respect your privacy as a fundamental right. This Privacy Policy transparently explains how we collect, use, share and protect the personal information you provide when visiting our website, using our services or interacting with us.',
    introHighlight: 'By using our services, you accept the practices described in this Privacy Policy.',
    introBadge1: 'Full Transparency',
    introBadge2: 'Maximum Security',
    introBadge3: 'Total Control',
    whatTitle: 'What information do we collect?',
    whatIntro: 'We collect different types of personal information so we can offer our professional services in the best way.',
    section1Title: '1. Information you provide to us',
    idCardTitle: 'Identification data',
    idCard1: 'Full name and surnames',
    idCard2: 'Identity document (ID, NIE, passport)',
    idCard3: 'Date of birth and nationality',
    contactCardTitle: 'Contact information',
    contactCard1: 'Email address',
    contactCard2: 'Mobile and landline phone numbers',
    contactCard3: 'Full postal address',
    profCardTitle: 'Professional data',
    profCard1: 'Company where you work and position',
    profCard2: 'Sector of professional activity',
    profCard3: 'Relevant work information',
    finCardTitle: 'Financial information',
    finCard1: 'Bank details (for payment processing)',
    finCard2: 'Required tax information',
    finCard3: 'Financial documentation for specific services',
    section2Title: '2. Information we collect automatically',
    autoIntroLabel: 'What do we collect?',
    autoIntroDesc: 'When you visit our website, we automatically collect certain technical information.',
    autoUseLabel: 'Usage data:',
    autoUseDesc: 'pages visited, time spent, links used',
    autoDeviceLabel: 'Device information:',
    autoDeviceDesc: 'device type, operating system, browser',
    autoLocLabel: 'Location information:',
    autoLocDesc: 'country and region (based on your IP address)',
    autoCookiesLabel: 'Cookies:',
    autoCookiesDesc: 'for more information, see our Cookie Policy',
    useTitle: 'How do we use your information?',
    useIntro: 'We use your personal information exclusively for the following legitimate purposes:',
    useServicesTitle: 'Core services',
    useService1: 'Provide and maintain our services',
    useService2: 'Process transactions and payments',
    useService3: 'Manage your account and profile',
    useService4: 'Fulfil contractual obligations',
    useCommTitle: 'Communication',
    useComm1: 'Reply to enquiries and requests',
    useComm2: 'Send service updates',
    useComm3: 'Provide technical support',
    useComm4: 'Communicate important information',
    useImproveTitle: 'Improvement and analysis',
    useImprove1: 'Personalise your experience',
    useImprove2: 'Analyse trends and usage',
    useImprove3: 'Improve our services',
    useImprove4: 'Develop new features',
    useSecTitle: 'Security and legal',
    useSec1: 'Detect fraudulent activity',
    useSec2: 'Comply with legal obligations',
    useSec3: 'Protect rights and safety',
    useSec4: 'Resolve legal disputes',
    legalTitle: 'Legal basis for processing',
    legalIntro: 'We process your personal information based on the following recognised legal grounds:',
    legal1Title: 'Contract performance',
    legal1Desc: 'When processing is necessary to fulfil our contractual obligations to you.',
    legal2Title: 'Consent',
    legal2Desc: 'When you have given explicit consent for processing for a specific purpose.',
    legal3Title: 'Legitimate interests',
    legal3Desc: 'When processing is necessary for our legitimate interests, provided your interests or fundamental rights do not prevail.',
    legal4Title: 'Legal obligation',
    legal4Desc: 'When processing is necessary to comply with an applicable legal obligation.',
    shareTitle: 'With whom do we share your information?',
    shareImportant: 'IMPORTANT: We do not sell your personal information to third parties',
    shareIntro: 'We may share your personal information only with the following categories of recipients:',
    share1Title: 'Service providers',
    share1Desc: 'Companies that provide services on our behalf (payment processing, data analytics, web hosting, customer support) under strict confidentiality agreements.',
    share2Title: 'Business partners',
    share2Desc: 'Third parties we collaborate with to offer specific services or joint promotions, always with your prior consent.',
    share3Title: 'Competent authorities',
    share3Desc: 'When necessary to comply with a legal obligation, court order or valid administrative requirement.',
    share4Title: 'Corporate transactions',
    share4Desc: 'In the context of a corporate transaction (such as a merger, acquisition or sale of assets), always protecting your rights.',
    intlTitle: 'International data transfers',
    intlIntro: 'Your personal data may be transferred and processed in countries other than the one where you reside. These countries may have different data-protection laws.',
    intlGuaranteeLabel: 'Protection guarantees:',
    intlGuaranteeDesc: 'When we transfer data outside the European Economic Area or Switzerland, we ensure adequate safeguards exist to protect your personal data, such as standard contractual clauses approved by the European Commission.',
    secTitle: 'How do we protect your information?',
    secIntro: 'We implement technical, administrative and physical security measures designed to protect the personal information we collect.',
    secTechTitle: 'Technical measures',
    secTech1: 'AES-256 encryption for storage',
    secTech2: 'Secure SSL/TLS communications',
    secTech3: 'Intrusion detection systems',
    secTech4: 'Encrypted backups',
    secAdminTitle: 'Administrative measures',
    secAdmin1: 'Access restricted to authorised personnel',
    secAdmin2: 'Regular data-protection training',
    secAdmin3: 'Internal security policies',
    secAdmin4: 'Periodic security audits',
    secLimitsLabel: 'Limitations:',
    secLimitsDesc: 'Although we implement the best available security measures, no system is completely impenetrable. We cannot guarantee absolute security of your personal information.',
    retentionTitle: 'How long do we keep your data?',
    retentionIntro: 'We keep your personal information only for the time necessary to fulfil the purposes described in this Privacy Policy, unless the law requires a longer retention period.',
    ret1Title: 'Contractual documents',
    ret1Desc: 'For the contract duration + 6 years',
    ret2Title: 'Tax documents',
    ret2Desc: '10 years (Swiss legal requirement)',
    ret3Title: 'Communications',
    ret3Desc: '3 years from last interaction',
    ret4Title: 'Browsing data',
    ret4Desc: 'Maximum 2 years',
    rightsTitle: 'What are your rights?',
    rightsIntro: 'Depending on where you live, you have important rights regarding your personal information:',
    rightAccessTitle: 'Right of access',
    rightAccessDesc: 'You can request information about what personal data we hold about you.',
    rightRectifyTitle: 'Right to rectification',
    rightRectifyDesc: 'You can request that we correct inaccurate or incomplete data.',
    rightDeleteTitle: 'Right to erasure',
    rightDeleteDesc: 'You can request that we delete your personal information.',
    rightPortTitle: 'Right to portability',
    rightPortDesc: 'You can receive your data in a structured format and transfer it.',
    rightOpposeTitle: 'Right to object',
    rightOpposeDesc: 'You can object to the processing of your data in certain circumstances.',
    rightWithdrawTitle: 'Withdraw consent',
    rightWithdrawDesc: 'You can withdraw your consent at any time.',
    rightsHowLabel: 'How to exercise your rights?',
    rightsHowDesc: 'To exercise these rights, contact us using the information provided in the "Contact" section of this policy.',
    faqTitle: 'Frequently asked questions about privacy',
    faqSubtitle: 'Clear answers to your most common questions.',
    faq1Q: 'What personal information does Punto Hispano collect?',
    faq1A: 'We collect identification, contact, professional and financial data necessary to provide our services. We only collect strictly necessary data and with your consent.',
    faq2Q: 'How does Punto Hispano protect my personal information?',
    faq2A: 'We implement advanced technical and administrative security measures, including AES-256 encryption, SSL/TLS communications and access restricted to authorised personnel only.',
    faq3Q: 'Can I request the deletion of my personal data?',
    faq3A: 'Yes, you have the right to request deletion of your data when no longer necessary for the purposes for which they were collected, always respecting applicable legal obligations.',
    faq4Q: 'Does Punto Hispano share my information with third parties?',
    faq4A: 'We do not sell your personal information. We only share it with trusted service providers, when necessary to comply with legal obligations or with your explicit consent.',
    changesTitle: 'Changes to this Privacy Policy',
    changesP1: 'We may update this Privacy Policy periodically to reflect changes in our practices or for other operational, legal or regulatory reasons.',
    changesNotifyLabel: 'We will notify you:',
    changesNotifyDesc: 'Any material change will be communicated by publishing the new Privacy Policy on our website and updating the "last updated" date.',
    contactTitle: 'Have questions about privacy?',
    contactIntro: 'If you have questions or concerns about this Privacy Policy or about the processing of your personal data, please contact us:',
    contactCompanyLabel: 'Company:',
    contactCompanyValue: 'Punto Hispano',
    contactAddressLabel: 'Address:',
    contactEmailLabel: 'Email:',
    contactPhoneLabel: 'Phone:',
    lastUpdated: 'Last updated:',
    lastUpdatedDate: '24 June 2025',
    lastUpdateNote: 'This policy may be modified to reflect changes in our practices or applicable regulations',
  },
  politicaCookiesPage: {
    seoTitle: 'Cookie Policy | Punto Hispano',
    seoDesc: 'Information about the cookies we use and how to manage your preferences.',
    title: 'Cookie Policy',
    subtitle: 'Full transparency about how we use cookies on our website',
    whatAreCookies: 'What are cookies and why do we use them?',
    whatAreCookiesP1: 'Cookies are small text files stored on your device when you visit our website. They are completely safe and help us provide a better browsing experience.',
    whatAreCookiesP2: 'At Punto Hispano we use cookies responsibly and transparently, always respecting your privacy and complying with European data protection regulations.',
    cookieTypes: 'What types of cookies do we use?',
    essentialTitle: 'Essential or necessary cookies',
    essentialWhat: 'What do they do?',
    essentialWhatDesc: 'They are essential for our website to function properly.',
    essentialWhy: 'Why do we need them?',
    essentialWhyDesc: 'They allow you to navigate the site, access secure areas and use basic features such as the contact form.',
    essentialNote: 'These cookies do not require your consent as they are technically necessary.',
    preferencesTitle: 'Preference cookies',
    preferencesWhatDesc: 'They remember your preferences to personalise your experience.',
    preferencesExamples: 'Selected language, accessibility settings, browsing preferences.',
    preferencesNote: 'They improve your experience but are not essential for basic operation.',
    analyticsTitle: 'Statistical or analytical cookies',
    analyticsWhatDesc: 'They help us understand how you use our website anonymously.',
    analyticsWhyDesc: 'We constantly improve our services based on real usage data.',
    analyticsNote: 'Data is processed anonymously and in aggregate; we never identify individual users.',
    marketingTitle: 'Marketing cookies',
    marketingWhatDesc: 'They allow us to show you more relevant content and offers.',
    marketingHowDesc: 'They track your browsing behaviour to personalise the experience.',
    marketingNote: 'You can always disable these cookies without affecting the basic operation of the site.',
    specificCookies: 'Specific cookies we use',
    tableName: 'Name',
    tableProvider: 'Provider',
    tablePurpose: 'Purpose',
    tableDuration: 'Duration',
    tableType: 'Type',
    controlTitle: 'How to control cookies?',
    controlDesc: 'You have full control over cookies. You can accept, reject or configure them according to your preferences.',
    onOurSite: 'On our website',
    onOurSiteDesc: 'When you visit for the first time, a banner appears where you can:',
    onOurSiteItems: ['Accept all cookies', 'Reject non-essential ones', 'Configure your preferences in detail'],
    inBrowser: 'In your browser',
    inBrowserDesc: 'You can also manage cookies directly from your browser:',
    inBrowserItems: ['Block all cookies', 'Delete existing cookies', 'Set exceptions per website'],
    browserSettings: 'Browser settings',
    thirdPartyCookies: 'Third-party cookies',
    thirdPartyWarning: 'Some external services we use (such as Google Analytics) may install their own cookies.',
    thirdPartyDesc: 'We have no direct control over these third-party cookies, but we ensure that:',
    thirdPartyItems: ['We only work with privacy-respecting providers', 'Data is processed anonymously', 'They comply with European data protection regulations', 'You can disable them if you wish'],
    changesTitle: 'Changes to our Cookie Policy',
    changesDesc: 'We may update this policy occasionally to reflect changes in our services or applicable regulations.',
    changesNotice: 'Any significant changes will be clearly communicated on our website and, if necessary, we will request your renewed consent.',
    questionsTitle: 'Questions about cookies?',
    questionsDesc: 'If you have questions about how we use cookies or want to exercise your rights, do not hesitate to contact us:',
    lastUpdated: 'Last updated:',
    lastUpdatedDate: '24 June 2025',
  },
  politicaGdprPage: {
    seoTitle: 'GDPR Policy | Personal Data Protection | Punto Hispano',
    seoDesc: 'Personal data protection policy under the GDPR. Know your rights and how we handle your information at Punto Hispano.',
    title: 'Personal Data Protection',
    subtitle: 'Your privacy is our priority — Know your rights under the GDPR',
    whyImportant: 'Why is your privacy important?',
    whyImportantP1: 'At Punto Hispano we treat your personal information with the utmost respect and transparency. We strictly comply with the General Data Protection Regulation (GDPR) and the Swiss Federal Data Protection Act.',
    whyImportantP2: 'This policy explains in simple terms what data we collect, how we use it and what your rights are as a user of our services.',
    whoResponsible: 'Who is responsible for your data?',
    whoResponsibleDesc: 'Punto Hispano Holding is the company responsible for processing your personal data.',
    ourAddress: 'Our address:',
    phoneLabel: 'Phone:',
    emailGeneralLabel: 'General email:',
    whatData: 'What information do we collect?',
    whatDataIntro: 'We only collect the information needed to provide our professional services. The amount and type of data depends on the service you request.',
    data1Title: '1. Basic identification data',
    data1What: 'What it includes:',
    data1WhatDesc: 'Full name, ID document, date of birth, nationality.',
    data1Why: 'Why we need it:',
    data1WhyDesc: 'Essential to provide legal and administrative services in Switzerland.',
    data2Title: '2. Contact information',
    data2WhatDesc: 'Postal address, phone numbers, email, emergency contact.',
    data2WhyDesc: 'To communicate with you and send important documents.',
    data3Title: '3. Professional and financial data',
    data3WhatDesc: 'Employment status, company, income, tax documents.',
    data3WhyDesc: 'For administrative, tax and insurance procedures.',
    data4Title: '4. Special data (only with your permission)',
    data4Important: 'Important:',
    data4ImportantDesc: 'We only handle sensitive data with your express consent.',
    data4WhatDesc: 'Marital status, health data (for medical insurance), banking information.',
    data4Control: 'Your control:',
    data4ControlDesc: 'You can withdraw this consent at any time.',
    rightsTitle: 'What are your rights?',
    rightsIntro: 'As a personal data subject, you have important rights you can exercise at any time:',
    right1Title: 'Right to know',
    right1Desc: 'You can request information about what data we hold, how we use it and with whom we share it.',
    right2Title: 'Right to rectify',
    right2Desc: 'If there is incorrect or incomplete data, you can request immediate correction.',
    right3Title: 'Right to be forgotten',
    right3Desc: 'You can request deletion of your data when no longer needed (respecting legal obligations).',
    right4Title: 'Right to data portability',
    right4Desc: 'You can receive your data in digital format to transfer it to another service provider.',
    howExercise: 'How to exercise your rights?',
    howExerciseIntro: 'It is very easy. You can contact us through any of these channels:',
    byEmail: 'By email',
    byEmailWrite: 'Write to:',
    byEmailNote: 'Include a copy of your ID',
    byPhone: 'By phone',
    byPhoneCall: 'Call:',
    byPhoneNote: 'Office hours',
    inPerson: 'In person',
    inPersonVisit: 'Visit our offices',
    inPersonNote: 'Request an appointment',
    responseTime: 'Response time:',
    responseTimeDesc: 'We respond within a maximum of 30 days. For complex cases we may need up to 60 days, but we will let you know.',
    howProtect: 'How do we protect your information?',
    securityMeasures: 'Security measures',
    securityIntro: 'We implement the best technical measures to protect your data:',
    security1: 'AES-256 encryption for storage',
    security2: 'Secure SSL/TLS communications',
    security3: 'Access restricted to authorised personnel only',
    security4: 'Encrypted backups',
    security5: 'Regular team training in data protection',
    retention: 'How long do we keep your data?',
    retentionIntro: 'We only keep your information as long as necessary:',
    retention1Label: 'Tax documents:',
    retention1Desc: '10 years (Swiss law)',
    retention2Label: 'Marketing:',
    retention2Desc: 'Until you withdraw consent',
    retention3Label: 'Communications:',
    retention3Desc: '3 years from last interaction',
    retention4Label: 'Web data:',
    retention4Desc: 'Maximum 2 years',
    international: 'International transfers',
    internationalDesc: 'If we need to transfer data outside Europe, we only do so to countries with adequate protection (such as Spain) or to certified providers in the US, always ensuring your protection.',
    questionsTitle: 'Have questions or complaints?',
    questionsIntro: 'If you have questions about this policy or how we handle your data, contact our Data Protection Officer:',
    emailLabel: 'Email:',
    complaintLabel: 'Right to complain:',
    complaintDesc: 'If you believe we are not complying with the regulations, you can file a complaint with the Swiss Federal Data Protection Authority (FDPIC) or the authority of your country of residence.',
    lastUpdated: 'Last updated:',
    lastUpdatedDate: '24 June 2025',
    updateNote: 'We will notify you of any important changes to this policy',
  },
  heroHome: {
    titleLine1: 'Stop Surviving.',
    titleLine2: 'Start Living in Switzerland.',
    subtitle: 'We know what it feels like to be lost with paperwork. Get your peace of mind back: we take care of everything.',
    cta: 'Discover Our Solutions',
    statFamilies: 'Happy Families',
    statFamiliesDesc: 'Already solved their paperwork',
    statYears: 'Years Solving',
    statYearsDesc: 'Real problems like yours',
    statAvailable: 'Always Available',
    statAvailableDesc: 'Whenever you need us, we are here',
    statSolutions: 'Solutions',
    statSolutionsDesc: 'For every problem you face',
  },
  footerLinks: {
    servicios: 'Services', gestoria: 'Agency', lifestyle: 'Lifestyle', empresa: 'Company', legal: 'Legal',
    gestoriaAdmin: 'Agency & Administration', asesoriaLegal: 'Legal Advisory', formacionIdiomas: 'Language Training', segurosPensiones: 'Insurance & Pensions',
    desempleoRav: 'Unemployment (RAV)', administracion: 'Administration', cvDoc: 'CV & Documents', acompanamientos: 'Accompaniments', traducciones: 'Translations', paquetes: 'Special Packages',
    vehiculos: 'Vehicle Rental', viviendas: 'Housing Rental', packRelocation: 'Relocation Pack', solucionesDigitales: 'Digital Solutions',
    sobreNosotros: 'About Us', blog: 'Blog', contacto: 'Contact', zonasServicio: 'Service Areas',
    privacidad: 'Privacy Policy', avisoLegal: 'Legal Notice', cookies: 'Cookie Policy', gdpr: 'GDPR',
    invalidEmail: 'Invalid email', errorRetry: 'Error. Please try again.', followUs: 'Follow us on',
  },
  navbar: {
    tagline: 'Your Agency & Advisory in', contactUs: 'Contact Us', closeMenu: 'Close menu', openMenu: 'Open menu',
    myProfile: 'My Profile', logout: 'Log Out', login: 'Login',
  },
  cart: {
    title: 'Your Cart', emptyCart: 'Your cart is empty', service: 'service', services: 'services', selected: 'selected', clearCart: 'Clear cart',
    limitedOffer: 'Limited Offer!', addMoreServices: 'Add more services and get exclusive discounts',
    numberOfPeople: 'Number of people:', couponPlaceholder: 'Coupon code', apply: 'Apply',
    subtotal: 'Subtotal:', persons: 'people:', discount: 'Discount:', total: 'Total:', continue: 'Continue', backToCart: '← Back to cart',
    couponInvalid: 'Invalid or expired coupon', couponExpired: 'This coupon has expired', couponMaxUses: 'This coupon has reached its usage limit',
    couponMinPurchase: 'Minimum purchase of {amount} CHF required', couponApplied: 'Coupon applied!', couponDiscount: 'Discount of {discount}',
    couponRemoved: 'Coupon removed', couponRemovedDesc: 'The discount has been removed', couponError: 'Error validating coupon',
    serviceRemoved: 'Service removed', serviceRemovedDesc: '"{title}" has been removed from cart',
    paymentMigration: 'Payments in migration', paymentMigrationDesc: 'We are moving this checkout to the new integrated panel. In the meantime, contact us to finalize your request.',
    paymentError: 'Could not continue', paymentErrorDesc: 'Please try again in a moment',
  },
  contactForm: {
    fullName: 'Full name', email: 'Email', phone: 'Phone', serviceArea: 'Service area', selectService: 'Select a service',
    message: 'Message', messagePlaceholder: 'Describe your inquiry or project...', characters: 'characters',
    send: 'Send message', sending: 'Sending...', formErrors: 'Form errors:', formErrorsDesc: 'Please correct the indicated errors.',
    tooManyAttempts: 'Too many attempts. Try again in {seconds} seconds.', submitError: 'Error submitting form. Please try again.',
    successTitle: 'Message sent', successDesc: 'Thank you for contacting us. We will reply soon.',
    errorTitle: 'Error', errorDesc: 'There was an error sending the message.',
    gestoriaOption: 'Agency & Administration', legalOption: 'Legal Advisory', segurosOption: 'Insurance & Pensions',
    idiomasOption: 'Language Courses', digitalOption: 'Digital Services', webOption: 'Web Design', crmOption: 'CRM',
    iaOption: 'Artificial Intelligence', automationOption: 'Automation', devOption: 'Custom Development', generalOption: 'General Inquiry',
    namePlaceholder: 'Your full name',
  },
  categoryHero: { requestInfo: 'Request Information', meetTeam: 'Meet our team' },
  gestoriaCategoryPage: {
    specializedAgency: 'Specialized Agency', professionalService: 'Professional service in Spanish for Spanish speakers in Switzerland.',
    freeConsultation: 'Free Consultation', callNow: 'Call Now',
    clientsServed: 'Clients served', fastResponse: 'Fast response', inSpanish: 'In Spanish', averageRating: 'Average rating',
    servicesOf: 'Services of', finalPrices: 'All prices are final. No hidden costs.', popular: 'Popular', add: 'Add', consult: 'Inquire',
    freeOrConsult: 'Free or inquire', freeOrConsultDesc: 'Contact us for more information about this service.',
    addedToCart: 'Added to cart',
    howItWorks: 'How does it work?', step1: 'Contact', step1Desc: 'Tell us your situation via WhatsApp or phone',
    step2: 'Documentation', step2Desc: 'We gather all necessary documentation', step3: 'Management', step3Desc: 'We handle all procedures for you',
    step4: 'Result', step4Desc: 'We deliver everything completed and explained',
    needHelp: 'Need help with', firstFree: 'First consultation free. No commitment.', whatsapp: 'WhatsApp',
  },
  categoryFaq: { defaultTitle: 'Frequently asked questions' },
  categoryBlog: { defaultTitle: 'Related articles', viewAll: 'View all articles', readMore: 'Read more' },
  categoryContact: {
    defaultTitle: 'Contact our experts', defaultDesc: 'Request information or a personalized quote',
    preferDirect: 'Prefer to speak directly?', teamAvailable: 'Our team is available to answer all your questions via WhatsApp or schedule a call.',
    formSent: 'Form submitted!', formSentDesc: 'Thank you for contacting us. A team member will get back to you as soon as possible.',
    sendAnother: 'Send another message', name: 'Name', namePlaceholder: 'Your full name', email: 'Email',
    phoneOptional: 'Phone (optional)', serviceArea: 'Service area', selectService: 'Select a service',
    message: 'Message', messagePlaceholder: 'Describe your inquiry in detail', sending: 'Sending...', send: 'Send message',
    successTitle: 'Form submitted successfully', successDesc: 'We will contact you as soon as possible',
  },
  writeReview: {
    title: 'Write a review', whereToWrite: 'Where would you like to write your review?',
    googleReview: 'Google Review', googleDesc: 'Public, appears on Google Maps',
    websiteReview: 'Review on our site', websiteDesc: 'Appears on our website after review',
    recommendGoogle: 'We also recommend writing on Google for maximum visibility',
    redirectGoogle: 'We will redirect you to Google', redirectGoogleDesc: 'You will be taken to Google Maps where you can write your public review.',
    goToGoogle: 'Go to Google Maps', goBack: 'Go back',
    nameLabel: 'Name *', emailLabel: 'Email *', ratingLabel: 'Rating *', starsOf: 'out of 5 stars',
    serviceUsed: 'Service used', selectServicePlaceholder: 'Select the service',
    reviewTitle: 'Review title', reviewTitlePlaceholder: 'Summary of your experience',
    yourReview: 'Your review *', yourReviewPlaceholder: 'Tell us about your experience with our services...',
    submitReview: 'Submit review', submitting: 'Submitting...',
    reviewNote: '* Your review will be reviewed before publishing. We also invite you to write on Google Maps.',
    requiredFields: 'Required fields', requiredFieldsDesc: 'Please complete all required fields.',
    reviewSent: 'Review submitted!', reviewSentDesc: 'Your review will be reviewed before publishing. Thank you for your feedback!',
    reviewError: 'Could not submit review. Please try again.',
    gestoria: 'Agency', legal: 'Legal Advisory', seguros: 'Insurance', idiomas: 'Language Training',
    web: 'Web Development', crm: 'CRM & Automation', general: 'General Inquiry',
  },
  blogNewsletter: {
    welcomeTitle: 'Welcome to our community!', welcomeDesc: 'You will receive our best content and exclusive tips in your email',
    title: 'Exclusive Newsletter for Spanish Speakers', subtitle: 'Receive weekly practical guides, tax news and legal advice for Spanish speakers in Switzerland',
    exclusive: 'Exclusive Content', exclusiveDesc: 'Guides not available on the blog',
    legalUpdates: 'Legal Updates', legalUpdatesDesc: 'Tax and legal changes in Switzerland',
    weeklyTips: 'Weekly Tips', weeklyTipsDesc: 'Practical tips every week',
    namePlaceholder: 'Your name (optional)', subscribing: 'Subscribing...', subscribe: 'Subscribe Free',
    noSpam: 'No spam. You can unsubscribe at any time.',
    invalidEmail: 'Invalid email', invalidEmailDesc: 'Please enter a valid email',
    successTitle: 'Successfully subscribed!', successDesc: 'We have sent you a confirmation email',
    errorTitle: 'Error', errorDesc: 'There was a problem with the subscription. Please try again.',
  },
  exitIntent: {
    defaultTitle: 'Wait! We have something for you', defaultDesc: 'Before you go, leave us your email and receive a free 15-minute consultation',
    defaultOffer: 'Free consultation', submit: 'I want my free consultation',
    sending: 'Sending...', thanks: 'Thank you! We will contact you soon',
    error: 'Error sending. Please try again', dismiss: 'No thanks, continue browsing',
  },
  contactInline: {
    nameFull: 'Full name', namePlaceholder: 'Your name', email: 'Email',
    phoneOptional: 'Phone (optional)', serviceInterest: 'Service of interest',
    selectService: 'Select a service', gestoria: 'Agency & Administration', legal: 'Legal Advisory',
    idiomas: 'Language Training', seguros: 'Insurance & Pensions', digital: 'Digital Solutions',
    coches: 'Car Rental', viviendas: 'Housing Rental', relocation: 'Relocation Pack',
    orientacion: 'Not sure — I need guidance',
    whatWorries: 'What concerns you?', tellUs: 'Briefly tell us your situation...',
    sending: 'Sending...', sendFree: 'Send My Free Inquiry',
    dataPrivacy: '🔒 Your data is confidential. We do not share your information with third parties.',
    sentTitle: 'Message Sent!', sentDesc: 'We will reply within 2 hours during business hours.',
    sendAnother: 'Send another message', successTitle: 'Message sent!', successDesc: 'We reply within 2 hours.',
    errorTitle: 'Error sending', errorDesc: 'There was a problem. Please try again.',
  },
  homeFeatured: {
    kicker: 'Featured services', deliveredThisYear: 'services delivered this year',
    title: 'Professional services in Switzerland for Spanish speakers',
    subtitle: 'Agency, legal advisory and digital transformation, all in your language',
    desc: 'Optimize taxes, regularize your situation and grow your business with a single team',
    viewAll: 'View All Services',
    gestoria: 'Tax Agency', gestoriaDesc: 'Personalized tax advice for individuals and companies in Switzerland.',
    gestoriaBtn: 'View agency services',
    legal: 'Legal Advisory', legalDesc: 'Specialized legal service for the Spanish-speaking community in Switzerland.',
    legalBtn: 'View legal services',
    digital: 'Digital Solutions', digitalDesc: 'Digital transformation to boost and modernize your business.',
    digitalBtn: 'View digital solutions',
    feat1: 'Tax returns', feat2: 'Tax planning', feat3: 'Accounting', feat4: 'Tax optimization',
    feat5: 'Immigration & residency', feat6: 'Employment contracts', feat7: 'Family law', feat8: 'Real estate advisory',
    feat9: 'Professional web design', feat10: 'Custom CRM systems', feat11: 'Process automation', feat12: 'Effective digital marketing',
  },
  homeStats: {
    title: 'Results that inspire trust', updated: 'Updated 2025',
    clients: 'Satisfied Clients', clientsDesc: 'Trusted us',
    procedures: 'Completed Procedures', proceduresDesc: 'Successful resolution',
    companies: 'Companies Created', companiesDesc: 'Across Switzerland',
    experience: 'Years of Experience', experienceDesc: 'Continued service',
  },
  homeTestimonials: {
    title: 'What Our Clients Say', subtitle: 'Real reviews from satisfied clients with our services',
    basedOn: 'Based on 50+ Google reviews', verified: 'Verified', googleReview: 'Google Review',
    viewAll: 'View all reviews', leaveReview: 'Leave us a review',
    usedServices: 'Have you used our services? Your opinion is very important to us.',
  },
  serviciosSection: {
    title: 'Services', titleAccent: 'key to your life in Switzerland',
    subtitle: 'Everything in one place, without language barriers.',
    gestoria: 'Agency & Administration', gestoriaDesc: 'Taxes and accounting without complications.',
    legal: 'Legal Advisory', legalDesc: 'Immigration, employment and family with bilingual lawyers.',
    idiomas: 'German Courses', idiomasDesc: 'Progress from the first week.',
    seguros: 'Insurance & 3rd Pillar', segurosDesc: 'Independent comparison. Real savings.',
    digital: 'Digital Solutions', digitalDesc: 'Web + CRM + AI to grow in Switzerland.',
    coches: 'Car Rental', cochesDesc: 'Flexible delivery, all risk, in Spanish.',
    viviendas: 'Housing Rental', viviendasDesc: 'We arrange visits and contracts, you choose.',
    relocation: 'Relocation Pack', relocationDesc: 'You arrive and we solve everything in 30 days.',
    bestSeller: 'Best seller 🔥', forHispanics: 'For Spanish speakers', save25: 'Save up to 25%', allInclusive: 'All inclusive ✅',
    learnMore: 'Learn more', customSolution: 'Need a custom solution?',
    customDesc: 'Contact our experts for a free consultation and discover how we can help you grow your business.',
    enterBtn: 'Enter', creating: 'Creating account...', createBtn: 'Create account',
    trustClients: 'Satisfied clients', trustResponse: 'Response time', trustResponseValue: '< 2 hours',
    trustLanguages: 'Languages', trustLanguagesValue: 'ES, DE, EN',
  },
  resetPassword: {
    seoTitle: 'New Password - Punto Hispano', seoDesc: 'Set your new password',
    successSeoTitle: 'Password Updated - Punto Hispano', successSeoDesc: 'Your password has been updated',
    invalidLink: 'Invalid or expired link', invalidLinkDesc: 'Please request a new recovery link',
    passwordMin: 'Password must be at least 8 characters',
    mismatch: 'Passwords do not match', mismatchDesc: 'Please verify both passwords are the same',
    tooShort: 'Password too short', tooShortDesc: 'Password must be at least 8 characters',
    successTitle: 'Password updated!', successDesc: 'Your password has been changed successfully',
    successRedirect: 'Your password has been changed successfully. You will be redirected automatically...',
    goToClient: 'Go to client area', newPassword: 'New Password', enterNew: 'Enter your new password to continue',
    newPasswordLabel: 'New password', minChars: 'Minimum 8 characters',
    confirmPassword: 'Confirm password', repeatPassword: 'Repeat your password',
    updating: 'Updating...', changePassword: 'Change password',
    errorTitle: 'Error changing password', errorDesc: 'There was a problem changing your password',
  },

  contactFormPage: {
    seoTitle: 'Contact Form | Punto Hispano',
    seoDesc: 'Contact us for inquiries about our services for the Spanish-speaking community in Switzerland.',
    title: 'Contact Form',
    subtitle: 'Fill out the form below to send us your inquiry. Our team will get back to you as soon as possible.',
    successTitle: 'Message Sent!',
    successDesc: 'Thank you for contacting us. We have received your message and will get back to you within 24-48 business hours.',
    sendAnother: 'Send another message',
    labelName: 'Full name',
    placeholderName: 'Enter your name',
    labelEmail: 'Email address',
    placeholderEmail: 'name@example.com',
    labelPhone: 'Phone (optional)',
    placeholderPhone: 'Your phone number',
    labelServiceArea: 'Service area',
    selectArea: 'Select an area',
    optGestoria: 'Administration & Paperwork',
    optLegal: 'Legal Advisory',
    optIdiomas: 'Language Courses',
    optSeguros: 'Insurance & Pensions',
    optDigital: 'Digital Solutions',
    optCoches: 'Car Rental',
    optViviendas: 'Housing Rental',
    labelMessage: 'Message',
    placeholderMessage: 'How can we help you?',
    submitBtn: 'Send Message',
    sending: 'Sending...',
    toastSuccess: 'Form submitted',
    toastSuccessDesc: 'We have received your message and will be in touch soon.',
    toastError: 'Error sending',
    toastErrorDesc: 'There was a problem sending your message. Please try again.',
    privacyNote: 'By submitting this form, you accept our',
    privacyLink: 'privacy policy',
    privacyNote2: 'and the processing of your data to respond to your inquiry.',
    fastResponse: 'Fast response',
    fastResponseDesc: '24-48 business hours',
    noCommitment: 'No commitment',
    noCommitmentDesc: 'Personalized quotes',
    spanishSupport: 'Spanish support',
    spanishSupportDesc: '100% Spanish-speaking team',
    validationName: 'Name must be at least 2 characters',
    validationEmail: 'Please enter a valid email address',
    validationService: 'Please select a service area',
    validationMessage: 'Message must be at least 10 characters',
    interestedIn: 'I am interested in information about the services of',
  },

  serviceTemplates: {
    freeWhatsapp: 'Free Consultation via WhatsApp',
    askWhatsapp: 'Request Info via WhatsApp',
    whatsappDirect: 'WhatsApp Direct',
    notSure: 'Not sure what you need? Message us — we\'ll guide you for free.',
    backTo: 'Back to',
    popular: 'Popular',
    bestSeller: 'Best Seller',
    allIncluded: 'All Included',
    free: 'Free',
    servicesAvailable: 'services available',
    serviceAvailable: 'service available',
    packagesAvailable: 'packages available',
    packageAvailable: 'package available',
    whichForYou: 'Which One Is Right for You?',
    freeConsultation: 'Free Consultation via WhatsApp',
    gestoriaBreadcrumb: 'Administration',
    legalBreadcrumb: 'Legal',
    legalFreeConsult: 'Free Consultation via WhatsApp',
    legalNotSure: 'Not sure what you need? We\'ll guide you for free.',
    segurosBreadcrumb: 'Insurance & Pension',
    segurosInsured: '+20,000 people insured in 5 years',
    relocationBreadcrumb: 'Relocation Pack',
    relocationNeedHelp: 'Hello, I need guidance about the Relocation Pack.',
  },
  cookieBanner: {
    title: 'Cookies',
    description: 'We use cookies to improve your experience.',
    moreInfo: 'More info',
    adjust: 'Customize',
    reject: 'Reject',
    accept: 'Accept',
    preferences: 'Preferences',
    necessary: 'Necessary',
    functional: 'Functional',
    analytics: 'Analytics',
    marketing: 'Marketing',
    required: 'required',
    onlyNecessary: 'Only necessary',
    save: 'Save',
  },
  sectionNav: {
    home: 'Home',
    services: 'Services',
    about: 'About Us',
    process: 'Process',
    testimonials: 'Testimonials',
    faq: 'FAQ',
    contact: 'Contact',
  },
  helpWidget: {
    help: 'Need help?',
    assistant: 'Assistant',
    minimize: 'Minimize help widget',
    howCanWeHelp: 'HOW CAN WE HELP YOU?',
    online: 'We are online',
    closeMenu: 'Close help menu',
    aiChat: 'AI CHAT',
    aiChatDesc: 'Instant response 24/7',
  },
};

export default en;
